export default {
	es: {
		guardar: "Guardar",
		volver: "< Volver",
		sin_definir: "Sin definir",
		guardar_datos: "Guardar datos",
		cancelar: "Cancelar",
		confirmar: "Confirmar",
		eliminar: "Eliminar",
		aceptar: "Aceptar",
		rechazar: "Rechazar",
		comenzar: "Comenzar",
		cerrar_sesion: "Cerrar sesión",
		ver_menos: "Ver menos",
		ver_mas: "Ver más",
		inicio: "Inicio",
		ver_detalles: "Ver detalles",
		guardar: "Guardar",
		editar: "Editar",
		anadir: "Añadir",
		enviar: "Enviar",
		requerido: "Requerido",
		revisar: "Revisar",
		oferta_text: "oferta",
		ofertas_text: "ofertas",
		editar_oferta: "Editar oferta",
		duplicar_oferta: "Duplicar oferta",
		cerrar_oferta: "Cerrar oferta",
		eliminar_oferta: "Elimina oferta",
		ver_como_candidato: "Ver como candidato",
		practicas: "Prácticas",
		empleo: "Empleo",
		ver: "Ver",
		enlaces: {
			politica_privacidad: "/politica-de-privacidad",
			politica_cookies: "/politica-de-cookies",
			login: "/login",
			solicitar_cuenta: "/solicitar-cuenta",
			registroalumno: "/registro",
			encuestas: '/encuestas',
			encuesta: '/encuesta',
			eventos: '/eventos',
			eventospublico: '/evento-publico',
			documentacion: '/documentacion',
			guiaOrientacion: '/guias-orientacion',
			ofertas_practicas: '/ofertas-practicas',
			ofertas_empleo: '/ofertas-empleo',
			cv: '/cv',
			vercv: '/ver-cv',
			mis_candidaturas: '/mis-candidaturas',
			mis_practicas: '/mis-practicas',
			orientacion: '/orientacion-laboral',
			propuesta_practicas: '/propuesta-practicas',
			propuesta_practicas_empresa: '/propuesta-practicas-empresa',
			programapracticasactivos: '/programas-practicas-activos',
			solicitarcambiopracticas: '/solicitar-cambio-practicas',
			subirconvenio: '/subir-convenio-firmado',
			generarnuevoconvenio: '/nuevo-convenio-colaboracion',
			practicaseducacion: '/solicitudes-practicas-educacion',
			nueva_oferta: '/nueva-oferta',
			editar_oferta: '/editar-oferta',
			mi_empresa: '/mi-empresa',
			mi_perfil: '/mi-perfil',
			mis_ofertas: '/mis-ofertas',
			mi_oferta: '/oferta',
			programa_practicas: '/programa-practicas',
			visualizar_oferta: '/visor-oferta',
			restablecer_login: '/restablecer-login',
			restablecer_candidato: '/restablecer-candidato',
			setear_pass: '/establecer-login',
			proteccion_datos: '/proteccion-de-datos',
			acceso_saml: '/acceso',
			logout: '/logout',
			ayuda: '/ayuda',
		},
		encabezado: {
			home: 'Bienvenid@',
			cv: 'Mi currículum',
			cv_view: 'Currículum del candidato',
			eventos: 'Eventos',
			propuesta_practicas: "Propuesta de prácticas",
			politica_privacidad: "Política de privacidad",
			politica_cookies: "Política de cookies",
			login: "Inicio de sesión",
			solicitar_cuenta: "Nueva empresa",
			registro_alumno: "Registro",
			ofertas_practicas: 'Listado de ofertas de prácticas',
			ofertas_empleo: 'Listado de ofertas de empleo',
			ficha_oferta_alumno_empleo: 'Listado de ofertas de empleo',
			ficha_oferta_alumno_practicas: 'Listado de ofertas de prácticas',
			mis_candidaturas: 'Mis candidaturas',
			mis_practicas: 'Mis prácticas',
			encuestas: 'Encuestas',
			orientacion: 'Orientación laboral',
			nueva_oferta: 'Nueva oferta',
			editar_oferta: 'Editar oferta',
			mi_empresa: "Mi empresa",
			mi_perfil: "Mi perfil",
			documentacion: 'Documentación',
			guiasOrientacion: 'Guías Orientación',
			documentacion_empresa: 'Documentación',
			documentacion_alumno: 'Mi documentación',
			mis_ofertas: 'Mis ofertas',
			mi_oferta: 'Mi oferta',
			ficha_oferta_empresa: 'Mi oferta',
			restablecer_login: 'Restablecer Contraseña',
			restablecer_candidato: 'Restablecer Contraseña',
			programapracticasactivos: 'Programas de prácticas activos',
			setear_pass: 'Establecer Contraseña',
			proteccion_datos: 'Protección de datos',
			visor_oferta: "Ver como alumno",
			fichaProgramaActivo: "Programas activos",
			solicitudCambioPracticas: "Solicitud cambio de prácticas",
			solicitudesEducacion: "Solicitudes ofertas educación",
			subirConvenioFirmado: 'Subir convenio firmado',
			generarNuevoConvenio: 'Nuevo convenio de Colaboración',
			ayuda: 'Ayuda',
			formulario_incorporacion: 'Formulario de incorporación'
		},
		ficha_oferta: {
			texto_programa_anadido: "Tienes este programa añadido a tu lista de programas informáticos"
		},
		formulario: {
			nombre: "Nombre",
			nombre_apellidos: "Nombre y apellidos",
			apellidos: "Apellidos",
			email: "Email",
			mensaje: "Mensaje",
			fecha_nacimiento: "Fecha de nacimiento",
			dia: "Día",
			mes: "Mes",
			anyo: "Año",
			area_interes: "Área de su interés",
			trabaja_actualmente: "¿Trabaja actualmente?",
			si: "Si",
			no: "No",
			carta_presentacion: "Carta de presentacion",
			meses: {
				Enero: "Enero",
				Febrero: "Febrero",
				Marzo: "Marzo",
				Abril: "Abril",
				Mayo: "Mayo",
				Junio: "Junio",
				Julio: "Julio",
				Agosto: "Agosto",
				Septiembre: "Septiembre",
				Octubre: "Octubre",
				Noviembre: "Noviembre",
				Diciembre: "Diciembre"
			},
			archivo_adjunto: "Adjuntar archivo",
			adjuntar_cv: "Adjuntar CV",
			introduce_mail: "Introduce tu email",
			pais: "País",
			telefono: "Teléfono",
			he_leido: "He leído y acepto la",
			y_acepto: "política de privacidad",
			enviar: "Enviar",
			enviado: "Enviado",
		},
		meses: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
		prelogin: {
			bienvenido: 'Acceso al Portal',
			selecciona_perfil: 'Selecciona tu perfil para consultar, publicar o gestionar prácticas académicas o formación en centros de trabajo.',
			usuarios: {
				estudiantes: 'Estudiantes',
				antiguos: "Alumni",
				empresas: 'Empresas'
			}
		},
		login: {
			iniciar_sesion: 'Iniciar sesión',
			acceder: 'Acceder',
			email: "Email",
			error_mail: "Por favor, indica tu email para logarte en el portal.",
			contrasena: "Contraseña",
			repetir_contrasena: "Repetir Contraseña",
			contrasena_olvidada: "He olvidado mi contraseña",
			introduce_email: 'Introduce tu email',
			email_mal: 'El email está mal formado',
			recuperar_pass: 'Recuperar mi contraseña',
			aun_no_registrado: "¿Aún no estas registrado/a?",
			alta_nueva_empresa: "Alta de nueva empresa",
			acceder_SSO: "ACCEDER SSO UNIVERSIDAD",
			indica_mail: "Por favor, indica tu <strong>{{$t('oferta.email')}}</strong> para logarte en el portal.",
			selecciona_empresa: "Por favor, selecciona la empresa con la que quieres logarte.",
			telefono_1 : "Teléfono",
			email_generico_empresa : "Email genérico empresa ",
			telefono_generico_empresa : "Teléfono genérico empresa ",
			popup_rgpd: {
				titulo: 'INFORMACIÓN AMPLIADA',
				detalle: 'Si necesitas ampliar información más detallada, puedes acceder a la Política de Protección de Datos en ',
				enlace: 'este enlace.',
				boton: 'Consiento, acceder'
			},
			restablecer_pass: {
				titulo: 'Sigue los pasos para restablecer tu contraseña',
				intro: 'La contraseña debe contener al menos 8 caracteres y un numero.',
				guardar: 'Guardar'
			},
			seteo_pass: {
				titulo: 'Sigue los pasos para establecer tu contraseña',
				intro: 'La contraseña debe contener al menos 8 caracteres y un numero.',
				guardar: 'Guardar'
			}
		},
		registro: {
			encabezado: 'Cumplimenta el formulario a continuación para darte de alta en el sistema:',
			datos_usuario: "Datos del usuario de empresa",
			datos_personales: "Datos personales",
			nombre: "Nombre",
			apellidos: "Apellidos",
			DNI: "DNI/NIF/NIE",
			CIF: "CIF de la empresa",
			puesto: "Puesto / Cargo",
			departamento: "Departamento",
			telefono_1: "Teléfono 1",
			telefono_2: "Teléfono 2",
			email: "Email",
			sede: "Sede por defecto",
			cargo: "Cargo",
			idioma: "Idioma preferido de comunicación",
			tipo_contacto: "Tipo de Contacto",
			contrasena: "Contraseña",
			repetir_contrasena: "Repetir Contraseña",
			direccion: "Dirección",
			pais: "País",
			selecciona_pais: "-selecciona un país-",
			provincia: "Provincia",
			selecciona_provincia: "-Selecciona una provincia-",
			localidad: "Localidad",
			selecciona_localidad: "-Selecciona una localidad-",
			direccion: "Dirección",
			direccion_empresa: "Dirección Empresa",
			cp: "Código Postal",
			titulo_2: "A continuación introduce los datos de tu empresa para darte de alta en el sistema:",
			anadir_imagen: "Haz click para añadir la imagen",
			autorizar_logo: "Autorizar uso del logo",
			nombre_fiscal: "Nombre fiscal o Razón social",
			nombre_comercial: "Nombre comercial",
			tipo_sociedad: 'Tipo de Sociedad',
			selecciona_tipo_sociedad: "-Selecciona tipo de sociedad-",
			tipo_empresa: "Tipo de Empresa",
			privada: "Privada",
			publica: "Pública",
			startup: "Startup",
			eliminar: "Eliminar",
			descripcion: "Descripción",
			si: "Sí",
			no: "No",
			sector: "Sector",
			selecciona_sector: "-Selecciona un sector-",
			otro_sector: "Otro Sector",
			numero_empleados: "Número de empleados",
			selecciona_empleados: "-Selecciona un rango-",
			web: "Web",
			iban: "Número cuenta IBAN",
			descripcion_empresa: "Descripción de la empresa",
			telefono: "Teléfono",
			CP : "Código Postal",
			firmante: {
				titulo: "A continuación introduce los datos del firmante que firmará los convenios:",
				nombre: "Nombre del firmante",
				apellidos: "Apellidos del firmante",
				email: "Email del firmante",
				dni: "DNI del firmante",
				cargo: "Cargo del firmante",
				telefono: "Teléfono"
			},
			envio_facturas: {
				titulo: "Dirección envío de facturas",
				titulo_2: "Dirección de facturación"
			},
			anadir_direccion: "Añadir nueva dirección de facturación",
			perfil_sectorial: "Perfil sectorial",
			sector_actividad: "Sector de actividad",
			selecciona_sector_actividad: "-Selecciona un sector-",
			rango: "Rango de facturación",
			selecciona_rango: "-Selecciona un rango-",
			numero_empleados: "Número de empleados",
			selecciona_numero_empleados: "-Selecciona un rango-",
			anyo_fundacion: "Año de fundación",
			politica_1: "He leído y acepto la ",
			politica_2: "política de privacidad",
			nuevo_contacto_titulo: "Datos del nuevo contacto de gestión",
			anadir_contacto: "Añadir contacto",
			nueva_cuenta_fiscal: "Datos de la cuenta nueva fiscal",
			domicilio_fiscal: "Domicilio Fiscal",
			poblacion: "Población",
			requiere_envio_postal: "Requiere envío postal facturas",
			domicilio_postal: "Domicilio para el envio postal de facturas",
			anadir_cuenta: "Añadir cuenta",
			datos_firmante: "Datos del firmante",

		},
		mi_practica: {
			subir_documentacion: "Subir documentación",
			descargar_anexo: "Descargar Anexo Firmado",
			descargar_certificado: "Descargar certificado de realización de prácticas",
			descargar_poliza: "Descargar póliza del seguro",
			titulo_practicas: "Para poder incorporarte a la realización de estas prácticas es necesario:",
			pagar_creditos: "Pagar los créditos que se van a reconocer.",
			descarga: "Descarga",
			aqui: "aquí",
			documento_pago: "el documento de Carta de Pago con la información de cantidades debidas e instrucciones.",
			contratar_poliza: "Contratar una póliza de accidentes que te cubra estas prácticas",
			puedes_contratar: "Puedes contratar cualquier póliza de seguro, si lo deseas puedes contratar online",
			mensaje_documentos: "Una vez tengas <strong>listos</strong> los documentos, por favor <strong>digitalízalos y adjúntalos</strong> a continuación. Revisaremos que son válidos antes de firmar el contrato con la empresa.",
			digitaliza_documentos: "Una vez tengas <strong>listo</strong> el documento, por favor <strong>digitalízalo y adjúntalo</strong> a continuación. Revisaremos que es válido antes de firmar el contrato con la empresa.",
			adjuntar_pago: "Adjuntar resguardo de pago",
			adjuntar_seguro: "Adjuntar póliza de seguro",
			descarga_ficheros: "Descarga los siguientes ficheros, firmalos y adjuntalos de nuevo.",
			enviar: "Enviar"
		},
		mis_practicas: {
			titulo: "En esta sección encontrarás toda la documentación referente a tus prácticas.",
			zero_1: "No hay ninguna práctica o documentación de prácticas para mostrar. En caso de duda, por favor",
			zero_2: "contacta con nosotros"
		},
		cambio_password: {
			titulo: "Cambiar contraseña",
			titulo_candidato: "¿Deseas cambiar tu contraseña?",
			contrasena_actual: "Contraseña actual",
			nueva_contrasena: "Nueva Contraseña",
			repetir_contrasena: "Repetir nueva Contraseña"
		},
		guia_orientacion: {
			titulo: "A continuación ponemos a tu disposición documentos en relación con tus prácticas o empleo, consejos y buenas prácticas que pueden ser de tu interés.",
			zero: "No hay guias de orientación"
		},
		mi_empresa: {
			intro: {
				cuerpo: 'Se muestran a continuación los datos principales de su empresa. Si alguno no es correcto, o necesita acceder, corregir, eliminar cualquier detalle de su información.',
				porfavor: 'Por favor, ',
				contacte: 'contacte con nosotros.'
			},
			datos_empresa: "Datos de la empresa",
		},
		candidaturas_options: {
			aceptar: "Aceptar inscripción",
			rechazar: "Rechazar inscripción",
			motivos_rechazo: "Motivos del rechazo",
			selecciona_motivo: "- Selecciona un motivo de rechazo -",
			rechazar_preinscripcion: "Rechazar preinscripción",
		},
		oferta: {
			intro_editor: "Cumplimenta el formulario a continuación para crear una oferta nueva:",
			tipo_oferta: "Tipo de oferta",
			numero_plazas: "Número de plazas",
			experiencia: "Experiencia",
			experiencia_deseable: "Experiencia deseable",
			horario: "Horario",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de finalización",
			tipo_contrato: "Tipo de contrato",
			salario: "Salario",
			creditos: "Créditos superados",
			otras_remuneraciones: "Otras remuneraciones",
			pais: "País",
			poblacion: "Población/Provincia",
			poblacion_only: "Población",
			provincia: "Provincia",
			sector: "Sector",
			area_funcional: "Área funcional",
			sede: "Sede/campus",
			beca: "Beca mensual",
			descripcion_puesto: "Descripción del puesto",
			tarea: "Tarea",
			otras_tareas: "Otras tareas",
			programa_practicas: "Programa de prácticas",
			aviso_programa: "Importante consultar para comprobar requisitos obligatorios",
			enlace_inscripcion: "Enlace de inscripción",
			ir_enlace: 'Ir al enlace',
			idiomas: "Idiomas",
			anadir_idiomas: "Añadir Idiomas",
			empleo: "Empleo",
			practicas: "Prácticas",
			certificacion: "- Certificación mínima requerida:",
			requerido: "- Requerido",
			estudios_obligatorios: "Estudios obligatorios",
			areas: "Áreas",
			estudios_deseables: "Estudios deseables",
			requisitos_obligatorios: "Requisitos obligatorios",
			etiquetas: "Etiquetas",
			otros_obligatorios: "Otros obligatorios",
			edad_maxima: "Edad maxima",
			salario_maximo: "Salario Máximo",
			intereses_deseables: "Intereses deseables",
			intereses_obligatorios: "Intereses obligatorios",
			intereses_seleccionados: "Intereses seleccionados",
			competencias_obligatorias: "Competencias obligatorias",
			competencias_seleccionadas: "Competencias seleccionadas",
			paises_nacionalidad_obigatorios: "Paises de Nacionalidad obligatorios",
			paises_residencia_obligatorios: "Paises de Residencia obligatorios",
			provincia_residencia_obligatorios: "Provincia de Residencia obligatorios",
			paises_seleccionados: "Paises seleccionados",
			provincias_seleccionados: "Provincias seleccionadas",
			coche_propio: "Coche propio",
			obligatorio_quest: "¿Obligatorio?",
			carnet_conducir: "Carnet de conducir",
			disponible_extranjero: "Disponible para trabajar en el extranjero",
			disponible_residencia: "Disponible para cambio de residencia",
			trabajando_actualmente: "Trabajando actualmente",
			requisitos_deseables: "Requisitos deseables",
			otros_requisitos_deseables: "Otros Requisitos deseables",
			otros_requisitos_obligatorios: "Otros requisitos obligatorios",
			motivos_exclusion: "Motivos de exclusión",
			competencias_deseables: "Competencias deseables",
			paises_nacionalidad_deseables: "Paises de Nacionalidad deseables",
			paises_residencia_deseables: "Paises de Residencia deseables",
			provincia_residencia_deseables: "Provincia de Residencia deseables",
			programas_informaticos: "Programas informáticos",
			programas_informaticos_deseables: "Programas informáticos deseables",
			documentos_requeridos: "Documentos requeridos",
			documentos: "Documentos",
			marca_documentos: "Marca los documentos que deben aportar los candidatos/as.",
			areas: "Áreas",
			marca_areas: "Marca las áreas a las que deben pertenecer los candidatos/as.",
			alguna_area_seleccionada: "Debe haber alguna área seleccionada para guardar la oferta.",
			anadir_otro_documento: "Añadir otro tipo de documento",
			nombre_documento_candidato: "Nombre del documento a aportar por el candidato",
			inscribirme: "Inscribirme",
			desinscribirme: "Desinscribirme",
			ya_inscrito: "ya estas inscrito",
			cancelar_inscripcion: "Cancelar inscripción",
			atencion: "¡Atención!",
			tramitar_inscripcion: "Para tramitar tu inscripción en esta oferta debes presentar tu candidatura en la web de la empresa ofertante.",
			acceder: "Para acceder",
			pincha_aqui: "pincha aquí.",
			especialidad: "Especialidad",
			estado: "Estado",
			datos_practica: "Datos de la práctica",
			paso_4: "Paso 4 de 4",
			tareas_a_desarrollar: "Tareas a desarrollar",
			horario: "Horario",
			horas_dia: "Horas al día",
			remuneracion: "Remuneración",
			otros_beneficios: "Otros beneficios",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",
			fecha_alta: "Fecha Alta",
			duracion_meses: "Duración (en meses)",
			dedicacion: "Dedicación (% jornada)",
			departamento: "Departamento",
			modalidad: "Modalidad",
			numero_dias_semana: "Numero de días por semana",
			dias_semana: "Días de la semana",
			vinculado_tfg: "Vinculado a TFG",
			nombre_tfg: "Nombre TFG",
			tutor_tfg: "Tutor/a TFG",
			solicitante: "Solicitante del servicio",
			centro_practicas: "Centro de prácticas",
			n_pedido: "Nº de pedido (si lo requiere)",
			observaciones: "Observaciones",
			direccion: "Dirección",
			nombre_tutor_uni: "Nombre y apellidos del tutor de la Universidad",
			datos_tutor_empresa: "Datos del tutor en la empresa",
			nombre: "Nombre",
			apellidos: "Apellidos",
			email: "Email",
			telefono: "Teléfono",
			cargo: "Cargo",
			dni: "DNI",
			titulacion_especialidad: "Titulación o especialidad",
			titulacion: "Titulación",
			selecciona: "-Seleccionar-",
			nombre_oferta: "Nombre de la oferta",
			numero_plazas: "Número de plazas",
			experiencia_requerida: "Experiencia requerida",
			experiencia_deseable: "Experiencia deseable",
			opciones_publicacion: "Opciones de publicación",
			url_inscripcion: "URL inscripción empresa",
			candidato_preferido: "Candidato/a preferido",
			datos_realizacion: "Datos de realización de la práctica",
			conocimientos_especificos: "Conocimientos especificos",
			formacion_adquirida: "Formación adquirida",
			seguimiento_previsto: "Seguimiento previsto",
			empresa_destino: "Empresa destino (solamente si es oferta de gestora/consultora ETT)",
			datos_tutor: "Datos del tutor/a de la empresa",
			para_estudiantes_ultimo_ano: "Para estudiantes de último año",
			para_perfil_no_universitario: "Para perfil no universitario",
			activo_quest: "¿Activo?",
			ano_promo_maximo: "Año de promoción máximo",
			enviar_quest: "¿Enviar?",
			candidato_leer: "Candidato/a por leer",
			candidatos_leer: "Candidatos/as por leer",
			candidato_total: "Candidato/a en total",
			candidatos_total: "Candidatos/as en total",
			ver_detalles: "Ver detalles",
			con_practicas: "- Con prácticas asignadas",
			fecha_caducidad: "Fecha de caducidad",
			buscar_mas_programa: "Busca más programas informáticos",
			programas_elegidos: "Programas informáticos elegidos",
			sin_programas: "Sin programas informáticos especificados",
			selecciona_idioma: "Selecciona un idioma",
			escribe_idioma: "Escribe aquí el idioma",
			idioma: "Idioma",
			indica_certificacion: "Indica aquí la certificación o nivel mínimo requerido",
			titulaciones: "Titulaciones",
			requeridas: "requeridas",
			deseables: "deseables",
			a_las_que: "a las que se dirige la oferta",
			notaMultiSelectTitulaciones: "Puede incluir una o varias titulaciones, pinchando sobre el nombre de aquella/s de su interés y volviendo a desplegar el listado. Verá todas las que ha seleccionado marcadas en color.",
			titulacion_seleccionada: "titulación seleccionada",
			titulaciones_seleccionadas: "titulaciones seleccionadas",
			nivel: "Nivel",
			areas: "Áreas",
			cualquier_area: "Cualquier área",
			ninguna_titulacion: "Ninguna titulación concuerda con el filtro de nivel indicado.",
			eliminar_todas: "Eliminar todas",
			areas_dirige: "Áreas a las que se dirige la oferta",
			titulaciones_dirige: "Titulaciones a las que se dirige la oferta",
			selecciona_titulaciones: "Selecciona las titulaciones en el listado de la izquierda",
			cumplimentar: "Cumplimentar solo en el caso de que lo considere información relevante para los candidatos/as.",
			tipo_estudios: "Tipo de estudios",
			seleccione_izquierda: "Selecciona las áreas en el listado de la izquierda.",
			seleccione_algun_nivel: "Seleccione algún nivel para cargar las áreas asociadas",
			especialidad_titulacion: "Especialidad o titulación/es",
			puesto_trabajo: 'Puesto de trabajo',
			motivo_rechazo: "Motivo de rechazo",
			ayuda_estudio: "Ayuda al estudio",
			tutor_empresa: "Tutor de la empresa",
			nombre_tutor: "Nombre del tutor empresa",
			apellidos_tutor: "Apellidos del tutor empresa",
			email_tutor: "Email del tutor empresa",
			telefono_tutor: "Teléfono del tutor empresa",
			cargo_tutor: "Cargo del tutor empresa",
			titulacion_tutor: "Titulación del tutor empresa",
			departamento_tutor: "Departamento del tutor empresa",
			dni_tutor: "DNI del tutor empresa",
			no_definido: "No definido",
			candidatos: "Candidatos/as",
			exportar: "Exportar",
			no_hay_candidatos: "No hay candidatos/as en esta oferta",
			mas: "más",
			menos: "menos",
			empresa_destino_simple: "Empresa Destino",
			tipo_formacion: "Tipo de formación",
			niveles: "Niveles",
			areas: "Áreas",
			para_estudiantes_ultimo_curso: "Para estudiantes de último curso",
			sucursal: "Sucursal",
			mandar_a_validar: "Mandar a validar",
			estimacion_total_horas: "Estimación total horas"
		},
		filtro_oferta: {
			buscar_nombre: "Busca por nombre del puesto",
			buscar_localizacion: "Busca por localización",
			buscar_titulacion: "Busca por titulación",
			buscar_puesto: "Busca por nombre del puesto",
			filtro_avanzado: "Filtro Avanzado",
			cerrar: "Cerrar",
			fecha_publicacion: "Fecha publicación",
			fecha_inicio_previsa: "Fecha de inicio de práctica prevista",
			fecha_inicio: "Fecha de inicio",
			filtrado_etiqueta: "Filtrado por etiquetas",
			omitir_inscritos: "Omitir ya inscritos",
			oferta_tfg: "Oferta TFG/TFM",
			ofertas_internacional: "Oferta internacional",
			ofertas_cv: "Ofertas que encajan con mi perfil/cv",
			busquedas_guardadas: "Búsquedas guardadas",
			guardar_busqueda: "Guardar búsqueda",
			borrar_filtros: "BORRAR FILTROS",
			ver: "Ver",
			fecha: "Fecha",
			se_han_encontrado: "Se han encontrado",
			introduce_nombre_busqueda: "Introduce el nombre de la búsqueda",
			sobreescribe_existente: "ó sobreescribe una existente",
			selecciona_busqueda: "Selecciona una búsqueda",
			ver_historico: "Ver histórico de ofertas",
			ver_actuales: "Ver ofertas actuales",
			crear_oferta: "CREAR OFERTA",
			historico_ofertas: "Histórico de ofertas",
			no_hay_ofertas: "No hay ofertas coincidentes con tu búsqueda",
			solo_con_candidatos: "Sólo ofertas con candidatos/as sin leer",
			tienen_candidatos: "Tienen candidatos/as",
			caduca_pronto: "Caducan pronto",
			no_leidos: "Solo no leidos"
		},
		popup_confirmacion: {
			recuerda: "¡Recuerda!",
			titulo: "Asegúrate de que los datos de tu perfil están actualizados antes de inscribirte a una oferta.",
			actualiza: "Actualízalo pinchando",
			aqui: "aquí.",
			confirma_titulo: "Por favor confirma que quieres ser candidato/a en esta oferta.",
			atencion: "¡Atención!",
			necesitamos_anadir: "Necesitamos que añadas los siguientes documentos para poder inscribirte a la oferta.",
			url_documento: "URL del documento",
			por_favor_adjunta: "Por favor, adjunta un archivo o url",
			alumnos_master: "Los alumnos de máster de 2 años de duración deben tener al menos el 50% de los créditos aprobados, a fecha de inicio de realización de las prácticas, para poder realizarlas. ¿Eres alumno de máster de duración inferior a 2 años, o has superado el 50% de los créditos?"
		},
		encuestas_obligatorias: {
			titulo: "Encuestas Obligatorias",
			cuerpo: "Por favor, antes de continuar, responda estas encuestas",
			no_puedes: "No puedes acceder al portal hasta que no hayas contestado las encuestas obligatorias. Si no deseas responder en este momento, puedes cerrar tu sesión.",
		},
		header: {
			hola: "Hola, ",
			oferta_practicas: "Buscar ofertas de prácticas",
			oferta_empleo: "Buscar ofertas de empleo",
			propuesta_practicas: "Propuesta de prácticas",
			candidaturas: "Mis candidaturas",
			practicas: "Mis prácticas",
			programas: "Programas",
			encuestas: "Encuestas",
			eventos: "Eventos",
			mi_cv: "Mi CV",
			guias_orientacion: "Guías Orientación",
			mis_ofertas: "Mis ofertas",
			nueva_oferta: "Nueva oferta",
			solicitar_cambio_practicas: "Solicitar cambio de prácticas",
			documentacion: "Documentación",
			solicitudes_practicas_educacion: "Solicitudes prácticas educación",
			encuestas: "Encuestas",
			mi_empresa: "Mi empresa",
			ayuda: "Ayuda",
			cerrar_sesion: "Cerrar sesión",
			solicitar_baja: "Solicitar baja"
		},
		image_uploader: {
			titulo: "Editar imagen de perfil",
			subtitulo: "Atención: si es posible, suba una imagen de proporciones 1:1. Si sube una imagen alargada o apaisada, puede ajustar el área de corte ampliando o reduciendo la imagen usando su scroll; puede además mover la imagen para ajustar el área de recorte arrastrándola con el ratón.",
		},
		notificaciones: {
			borrar_todo: "Borrar todo",
			importantes: "Importantes",
			otras_notificaciones: "Otras notificaciones",
			no_notificaciones: "No tienes notificaciones pendientes"
		},
		popup_borrar_cuenta: {
			titulo: "¿Desea solicitar la baja del servicio y la supresión de sus datos personales?",
			si: "Sí",
			no: "No"
		},
		popup_pedir_naf: {
			titulo: "¡Atención!",
			subtitulo: "Todos los estudiantes deben aportar su Número de Seguridad Social (NSS o NAF) en su perfil. Debes completar:",
			parrafo1: "1. El campo Nº Seguridad social: en la sección de Datos personales de tu cv.",
			parrafo2: "2. Adjuntar el documento de acreditación del Número de la Seguridad Social en la sección Documentación adjunta, apartado disponible al final de tu cv.",
			pie: "Accede ya para cumplimentarlo.",
			ir: "Ir ahora",
		},
		popup_faltan_datos_empresa: {
			atencion: "¡Atención!",
			cuerpo_1: "Faltan datos obligatorios en tu perfil, por favor accede para completarlos.",
			cuerpo_2: "Faltan datos obligatorios en el perfil de tu empresa, por favor accede para completarlos.",
			ir_a_perfil: "Ir a mi Perfil",
			ir_a_empresa: "Ir a Mi empresa"
		},
		popup_datos_personales: {
			atencion: "¡Atención!",
			titulo: "Antes de poder continuar debes completar los siguientes datos obligatorios de tu perfil:",
			ir_a_perfil: "Ir a mi Perfil"
		},
		solicitudes_educacion: {
			titulo: "En esta sección encontrarás la información de los estudiantes que han solicitado la realización de prácticas en su centro.",
			zero: "No hay documentación en estos momentos."
		},
		filtro_candidaturas: {
			buscar_nombre: "Busca por nombre del puesto",
			empleo: "Empleo",
			practicas: "Prácticas",
			filtro_avanzado: "Filtro Avanzado",
			cerrar: "Cerrar",
			estado: "Estado",
			ver: "Ver",
			borrar_filtros: "BORRAR FILTROS",
			estas_en: "Estas en",
			zero: "No hay procesos de selección coincidentes con tu búsqueda"
		},
		documentacion: {
			intro: "En esta sección encontrarás la documentación relacionada con las prácticas que se han realizado en tu empresa.",
			convenio_titulo: "Convenios de colaboración",
			caducado: "(Caducado) -",
			zero_convenio: "Aún no tienes ningún convenio",
			titulo_convenio: "Si lo deseas puedes solicitar y descargar el convenio de colaboración, o aportar el documento ya firmado por tu empresa:",
			nuevo_convenio: "Nuevo convenio",
			subir_convenio: "Subir convenio firmado",
			anexos_practicas: "Anexos de prácticas",
			zero_practicas: "Aún no tienes contenido",
			notas_formativas: "Notas formativas",
			en: "en",
			otros_documentos: "Otros documentos asociados a prácticas",
			zero_documentos: "Aún no tienes ningún documento de prácticas",
			otros_documentos_programas: "Otros documentos asociados a programas",
			zero_documentos_practicas: "Aún no tienes ningún documento asociado a programas",
			documentos_aportados_empresa: "Otros documentos aportados por la empresa",
			no_documentos_anadidos: "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
			anadir_documentacion: "Añadir documentación",
			selecciona_documento: "Selecciona un documento",
			listado_documento: "Listado de documentos",
			otro_tipo_documento: "Otro tipo de documento",
			nombre_documento: "Nombre del documento",
			url_documento: "URL del documento",
		},
		encuestas: {
			titulo: "Encuestas",
			obligatorias: "Para continuar, responde todas las preguntas obligatorias",
			enviar: "Enviar",
			pagina: "Página",
			datos_enviados: "Tus datos han sido enviados",
			muchas_gracias: "¡Muchas gracias!",
			iniciar_sesion: "Inicia sesión con tu usuario",
			empresa: "Empresa",
			candidato: "Candidato",
			usuario: "Usuario",
			contrasena: "Contraseña",
			acceder: "Acceder",
			o: 'ó',
			acceder_anonimamente: "Acceder anonimamente",
			contestar_pregunta: "Debes contestar a esta pregunta para continuar",
			zero: "No hay encuestas disponibles"
		},
		eventos: {
			proximos: "Próximos eventos",
			pasados: "Eventos pasados",
			evento_destacado: "Evento destacado",
			desde: "Desde",
			hasta: "Hasta",
			organizado_por: "Organizado por",
			inscribirse: "Inscribirse",
			inscrito: "Inscrito",
			mas_informacion: "Más información",
			galeria: "Galería de imágenes",
			videos: "Vídeos",
			buscar_localizacion: "Buscar por localización",
			buscar_categoria: "Buscar por categoría",
			buscar_nombre: "Buscar por nombre",
			eventos_pasados: "Eventos ya pasados",
			ver_mas: "Ver más"
		},
		comunicaciones: {
			titulo: "Comunicaciones"
		},
		guias: {
			titulo: "Últimas guías de orientación",
			zero: "No hay guias de orientación"
		},
		ofertas: {
			ultimas_practicas: "Últimas Ofertas de prácticas",
			practicas: "Prácticas",
			ultimas_empleo: "Últimas Ofertas de empleo",
			empleo: "Empleo",
			ofertas: "Ofertas",
			zero_ofertas: "En estos momentos no hay ninguna oferta con visibilidad para tu perfil. En caso de duda, por favor contacta con nosotros.",
			ver_todas: "Ver todas",
			ver_todas_ofertas_actuales: "Ver todas las ofertas de prácticas actuales para tu perfil",

		},
		cv: {
			nivel: "Nivel",
			programa_informatico: "Programa informático",
			certificado: "Certificado",
			sin_nivel: "Sin nivel definido",
			presentacion: "Presentación",
			anadir_presentacion: "Para añadir tu presenctación pulsa",
			aqui: "aquí",
			otros_intereses: "Otros intereses",
			tus_interes: "Tus intereses",
			sin_intereses: "Sin intereses especificados",
			escribe_interes: "Escribe algún interes, para comenzar a buscar",
			click_interes: "Haz click sobre el interes, para añadirlo",
			click_cambiar_imagen: "Haz click para cambiar la imagen",
			cambiar_contrasena: "Cambiar contraseña",
			idiomas: "Idiomas",
			idioma: "Idioma",
			sin_idiomas: "Sin idiomas añadidos, pulsa en añadir idioma para añadirlo",
			idioma_obligatorio: "El idioma y el nivel son campos obligatorios para añadir un idioma",
			nivel_no_definido: "Nivel no definido",
			nivel: "Nivel",
			nombre_certificado: "Nombre del certificado",
			estancia_extranjero: "Estancia en el extranjero",
			pais_estancia: "País de estancia",
			motivo_estancia: "Motivo de la estancia",
			duracion_meses: "Duración en meses",
			experiencia_profesional: "Experiencia profesional",
			anadir_nueva_experiencia: "Añadir nueva experiencia",
			sin_experiencia: "Sin experiencia",
			actualidad: "Actualidad",
			puesto: 'Titulo del puesto',

			sector_empresa: "Sector de la empresa",
			area_actividad_puesto: "Área de actividad del puesto",
			tipo_contrato: "Tipo de contrato",
			subtipo_contrato: "Subtipo de contrato",
			ver_adjunto: "Ver adjunto",
			ver_enlace: "Ver enlace",
			duracion: "Duración",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",
			provincia: "Provincia",
			empresa: "Empresa",
			enlace: "Enlace",
			descripcion_puesto: "Descripción del puesto",
			escribe_descripcion: "Escribe una descripción de las tareas desempeñadas",
			anadir_fichero: "Añadir fichero adjunto",
			adjunto_correctamente: "Archivo adjunto correctamente",
			programas_informaticos: {
				titulo: "Programas informáticos",
				buscar: "Escribe para buscar",
				zero: "No hay programas informáticos añadidos, pulsa en añadir para añadirlos",
				anadir: "Añadir Programa",
			},
			documentacion_adjunta: "Documentación adjunta",
			documentacion_subida: "Documentación subida el",
			no_hay_documentos: "No hay documentos añadidos",
			pulsa_anadir_documentos: ", pulsa en añadir documento para añadirlo",
			anadir_documentacion: "Añadir documentación",
			selecciona_documento: "Selecciona un documento",
			listado_documento: "Listado de documentos",
			otro_tipo_documento: "Otro tipo de documento",
			nombre_documento: "Nombre del documento",
			url_documento: "URL del documento",
			documentacion_privada: "Documentación privada",
			no_documentos: "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
			documentacion_ligada: "Documentación ligada a procesos",
			datos_profesionales: "Datos profesionales",
			visitar: "Visitar",
			indica_link_perfil: "Indica link a tu perfil",
			trabajando_actualmente: "Trabajando actualmente",
			permiso_trabajo: "Permiso de trabajo en la UE",
			anos_experiencia: "Años de experiencia",
			sin_experiencia: "Sin experiencia",
			disfrutado_erasmus: "He estado de Erasmus o he disfrutado de otra beca de movilidad",
			minima_retribucion: "Mínima retribución",
			brutos_anuales: "/ brutos anuales",
			datos_personales: "Datos personales",
			dni: "DNI",
			fecha_nacimiento: "Fecha de nacimiento",
			genero: "Género",
			femenino: "Femenino",
			masculino: "Masculino",
			email_personal: "Email",
			email_estudiante: "Email de estudiante",
			avisos_en_email: "Avisos en el email personal",
			acepta_newsletter: "Acepta newsletter",
			idioma_comunicaciones: "Idioma preferido para las comunicaciones",
			movil: "Movil",
			fijo: "Teléfono fijo",
			direccion_empadronamiento: "Dirección de empadronamiento",
			direccion_actual: "Dirección actual",
			direccion: "Dirección",
			iban: "Nº cuenta IBAN",
			seguridad_social: "Nº Seguridad social",
			pais_nacionalidad: "País de nacionalidad",
			pais_segunda_nacionalidad: "País de segunda nacionalidad",
			provincia_nacimiento: "Provincia de nacimiento",
			provincia: "Provincia",
			lugar_nacimiento: "Lugar de nacimiento",
			discapacidad: "Discapacidad superior al 33%",
			deseo_recibir_comunicaciones: "Deseo recibir comunicaciones relacionadas con orientación y servicios relacionados con la formación superior y la UIB:",
			nombre: "Nombre",
			primer_apellido: "Primer apellido",
			segundo_apellido: "Segundo apellido",
			tipo_identificacion: "Tipo de identificación",
			documento_identidad: "Documento de identidad",
			buscar: "Escribe para buscar",
			cp: "Código Postal",
			pais: "País",
			localidad: "Localidad",
			tipo_via: "Tipo de vía",
			numero: "Número",
			piso: "Piso",
			puerta: "Puerta",
			notas: "Notas",
			datos_academicos: "Datos académicos",
			formacion_complementaria: "Formación complementaria",
			anadir_titulacion: "Añadir nueva titulación",
			complementaria: "complementaria",
			centro: "Centro",
			tipo: "Tipo",
			nota: "Nota",
			rama_ensenanza: "Rama de la enseñanza",
			duracion: "Duración",
			actual: "Actual",
			si: "Sí",
			no: "No",
			titulo: "Titulo",
			universidad: "Universidad/Lugar de estudios",
			calificacion: "Calificación",
			calificacion_media: "Calificación media del titulo",
			formacionAcademica: "Formación académica",
			horas: "Horas",
			ambito: "Ambito de la enseñanza",
			selecciona_tipo: "- Selecciona un tipo -",
			certificacion: "Certificación",
			tienes_cerfificacion: "¿Tienes certificación?",
			competencias_profesionales: "Competencias profesionales",
			tus_competencias: "Tus competencias",
			sin_competencias: "Sin competencias profesionales especificadas",
			solicitar_sesion: "Puedes solicitar una sesión gratuita de orientación con DOIP UIB.",
			datos_interes: "Datos de interés",
			competencias: "Competencias",
			busqueda_activa_practicas: "Búsqueda activa de prácticas",
			busqueda_activa_empleo: "Búsqueda activa de empleo",
			disponible_extranjero: "Disponible para trabajar en el extranjero",
			permiso_conducir: "Permiso de conducir",
			disponible_cambio_residencia: "Disponible para cambio de residencia",
			coche_propio: "Coche propio",
			disponible_viajar: "Disponible para viajar",
			discapacidad_certificada: "Discapacidad certificada",
			observaciones: "Observaciones",
			carnet_moto: "Carnet de moto",
			moto_propia: "Moto propia",
			disponibilidad_jornadas: "Disponilidad de jornadas",
			periodo_preferencia_practicas: "Periodo preferencia de prácticas",
			selecciona: "Selecciona",

		},
		addtitulacion: {
			titulo: "Titulaciones a las que se dirige la oferta",
			seleccione_areas: "Seleccione área/s para filtrar titulaciones",
			borrar_areas: "Borrar todas las áreas",
			cualquier_area: "Cualquier área",
			escriba_aqui: "Escriba aquí para filtrar el listado de titulaciones a continuación",
			selecciona_titulacion: "Seleccione la titulación/es a la/s que se dirige la oferta haciendo clic sobre ella/s",
			ver_titulaciones: "Ver titulaciones de grado",
			listadas: "listadas",
			listados: "listados",
			cualquier_titulacion: "Cualquiera de estas titulaciones de grado",
			ver_titulaciones_postgrado: "Ver titulaciones de postgrado",
			cualquier_titulacion_postgrado: "Cualquiera de estas titulaciones de postgrado",
			ver_titulaciones_propio: "Ver titulaciones de Título propio",
			cualquier_titulacion_propio: "Cualquiera de estos títulos propios",
			lo_sentimos: "Lo sentimos no se han encontrado titulaciones que coincidan con la búsqueda",
			listado_titulaciones_seleccionadas: "Listado de titulaciones seleccionadas",
			eliminar_titulaciones: "Eliminar todas las titulaciones seleccionadas"
		},
		candidato: {
			nuevo: "Nuevo",
			cambiar_estado: "Cambiar estado",
			ver_cv: "Ver CV",
			detalles: "Detalles del candidato/a",
			selecciona_estado: "Selecciona un estado",
			seleccione_motivo: "Por favor seleccione el motivo de rechazo del candidato/a.",
			cambio_estado: "Cambio de estado",
			descargar_cv: "Descargar CV",
			cumplimentar_formulario_incorporacion: "Cumplimentar Formulario de Incorporación"

		},
		cambio_practicas: {
			identifica: "Identifica el alumno/a del que solicitan realizar prórroga o variación de sus condiciones de prácticas.",
			alumno: "Alumno",
			selecciona_oferta: "Selecciona la oferta",
			no_practicas: "Aún no tienes ninguna práctica sobre la que puedas solicitar un cambio.",
			alumno: "Alumno/a",
			selecciona_alumno: "Selecciona el alumno/a",
			detalles: "Detalles de la modificación",
			tipo_modificacion: "Tipo de modificación",
			selecciona_modificacion: "-Selecciona la modificación-",
			otros_detalles: "Otros detalles",
			adjunto: "Adjunto",
			solicitar_cambio: "Solicitar cambio"
		},
		formulario_incorporacion: {
			formularioYaCumplimentado: "Este formulario de incorporación ya ha sido cumplimentado y el alumno ha sido seleccionado.",
			encabezado: "Rellena el formulario de incorporación para completar la candidatura del alumno y pasarla a seleccionado.",
			datos_departamento_acogida: "Datos del departamento de acogida",
			nombre_departamento_acogida: "Nombre del departamento de acogida",
			responsable_departamento_acogida: "Responsable del Departamento de acogida",

			datos_empresa_institucion: "Datos de la Empresa/Institución:",
			CIF: "CIF",
			razon_social: "Razón Social",
			domicilio_social: "Domicilio Social",
			cp: "C.P.",
			localidad: "Localidad",
			selecciona_localidad: "-Selecciona una localidad-",
			provincia: "Provincia",
			selecciona_provincia: "-Selecciona una provincia-",
			sector_empresa: "Sector de la Empresa",
			selecciona_sector: "-Seleccionau un sector-",
			area_funcional: "Area funcional",
			selecciona_area_funcional: "-Selecciona una area funcional-",
			descripcion_actividad_empresa: "Breve descripción de la actividad a la que se dedica la Empresa",

			persona_de_contacto: "Persona de contacto",
			contacto_nombre_apellidos: "Nombre y apellidos",
			contacto_cargo_departamento: "Cargo/Departamento",
			contacto_email: "E-mail",
			contacto_num_telefono: "Nº de Teléfono",

			persona_firmante_anexo_convenio: "Persona firmante del Anexo",
			persona_firmante_convenio_empresa: "Persona firmante del convenio empresa",
			firmante_nombre_apellidos: "Nombre y apellidos",
			firmante_nombre: "Nombre",
			firmante_apellidos: "Apellidos",
			firmante_cargo_departamento: "Cargo/Departamento",
			firmante_email: "E-mail",
			firmante_dni: "DNI",

			datos_alumno: "Datos del Alumno",
			alumno_dni: "DNI",
			alumno_nombre_apellidos: "Nombre y apellidos",
			alumno_titulacion: "Titulación",
			alumno_curso_estudios: "Curso Estudios",

			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",

			datos_periodo_practicas: "Datos sobre el Periodo de Prácticas",
			fecha_comienzo_practicas: "Fecha de comienzo de prácticas",
			fecha_finalizacion_practicas: "Fecha de finalización de prácticas",
			
			lugar_realizacion_practicas: "Lugar de realización de las prácticas",
			sucursal: "Sucursal",
			selecciona_sucursal: "-Selecciona una sucursal-",

			datos_tutor_empresa: "Datos del tutor en la empresa",
			tutor_nombre: "Nombre",
			tutor_apellidos: "Apellidos",
			tutor_cargo: "Cargo en Empresa",
			tutor_email: "E-mail",
			tutor_departamento_seccion: "Departamento o Sección",

			horario_trabajo_sugerido_empresa: "Horario de trabajo sugerido por la empresa",
			num_dias_semana: "Número de días a la semana",
			num_horas_dia: "Número de horas al día",
			estimacion_horas_periodo: "Estimación del cómputo total de horas a realizar",

			datos_de_las_practicas: "Datos de las prácticas",
			retribucion_euros_mes: "Retribución € brutos/mes",
			descripcion_actividad: "Descripción detallada de la actividad a realizar por el alumno (imprescindible para valorar y aprobar su idoneidad)",
			descripcion_competencias: "Descripción de las competencias básicas, genéricas y/o específicas que debe adquirir el alumno durante la realización de las Prácticas (imprescindible para valorar y aprobar su idoneidad)",
		}
	},
	la: {
		guardar: "Guardar",
		volver: "< Volver",
		sin_definir: "Sin definir",
		guardar_datos: "Guardar datos",
		cancelar: "Cancelar",
		confirmar: "Confirmar",
		eliminar: "Eliminar",
		aceptar: "Aceptar",
		rechazar: "Rechazar",
		comenzar: "Comenzar",
		cerrar_sesion: "Cerrar sesión",
		ver_menos: "Ver menos",
		ver_mas: "Ver más",
		inicio: "Inicio",
		ver_detalles: "Ver detalles",
		guardar: "Guardar",
		editar: "Editar",
		anadir: "Añadir",
		enviar: "Enviar",
		requerido: "Requerido",
		revisar: "Revisar",
		oferta_text: "vacante",
		ofertas_text: "vacantes",
		editar_oferta: "Editar vacante",
		duplicar_oferta: "Duplicar vacante",
		cerrar_oferta: "Cerrar vacante",
		eliminar_oferta: "Elimina vacante",
		ver_como_candidato: "Ver como candidato",
		practicas: "Prácticas",
		empleo: "Empleo",
		ver: "Ver",
		enlaces: {
			politica_privacidad: "/politica-de-privacidad",
			politica_cookies: "/politica-de-cookies",
			login: "/login",
			solicitar_cuenta: "/solicitar-cuenta",
			registroalumno: "/registro",
			encuestas: '/encuestas',
			encuesta: '/encuesta',
			eventos: '/eventos',
			eventospublico: '/evento-publico',
			documentacion: '/documentacion',
			guiaOrientacion: '/guias-orientacion',
			ofertas_practicas: '/ofertas-practicas',
			ofertas_empleo: '/ofertas-empleo',
			cv: '/cv',
			vercv: '/ver-cv',
			mis_candidaturas: '/mis-candidaturas',
			mis_practicas: '/mis-practicas',
			orientacion: '/orientacion-laboral',
			propuesta_practicas: '/propuesta-practicas',
			propuesta_practicas_empresa: '/propuesta-practicas-empresa',
			programapracticasactivos: '/programas-practicas-activos',
			solicitarcambiopracticas: '/solicitar-cambio-practicas',
			subirconvenio: '/subir-convenio-firmado',
			generarnuevoconvenio: '/nuevo-convenio-colaboracion',
			practicaseducacion: '/solicitudes-practicas-educacion',
			nueva_oferta: '/nueva-oferta',
			editar_oferta: '/editar-oferta',
			mi_empresa: '/mi-empresa',
			mi_perfil: '/mi-perfil',
			mis_ofertas: '/mis-ofertas',
			mi_oferta: '/oferta',
			programa_practicas: '/programa-practicas',
			visualizar_oferta: '/visor-oferta',
			restablecer_login: '/restablecer-login',
			restablecer_candidato: '/restablecer-candidato',
			setear_pass: '/establecer-login',
			proteccion_datos: '/proteccion-de-datos',
			acceso_saml: '/acceso',
			logout: '/logout',
			ayuda: '/ayuda',
		},
		encabezado: {
			home: 'Bienvenid@',
			cv: 'Mi currículum',
			cv_view: 'Currículum del candidato',
			eventos: 'Eventos',
			propuesta_practicas: "Propuesta de prácticas",
			politica_privacidad: "Política de privacidad",
			politica_cookies: "Política de cookies",
			login: "Inicio de sesión",
			solicitar_cuenta: "Nueva empresa",
			registro_alumno: "Registro",
			ofertas_practicas: 'Listado de vacantes de prácticas',
			ofertas_empleo: 'Listado de vacantes de empleo',
			ficha_oferta_alumno_empleo: 'Listado de vacantes de empleo',
			ficha_oferta_alumno_practicas: 'Listado de vacantes de prácticas',
			mis_candidaturas: 'Mis postulaciones',
			mis_practicas: 'Mis prácticas',
			encuestas: 'Encuestas',
			orientacion: 'Orientación laboral',
			nueva_oferta: 'Nueva vacante',
			editar_oferta: 'Editar vacante',
			mi_empresa: "Mi empresa",
			mi_perfil: "Mi perfil",
			documentacion: 'Documentación',
			guiasOrientacion: 'Guías Orientación',
			documentacion_empresa: 'Documentación',
			documentacion_alumno: 'Mi documentación',
			mis_ofertas: 'Mis vacantes',
			mi_oferta: 'Mi vacante',
			ficha_oferta_empresa: 'Mi vacante',
			restablecer_login: 'Restablecer Contraseña',
			restablecer_candidato: 'Restablecer Contraseña',
			programapracticasactivos: 'Programas de prácticas activos',
			setear_pass: 'Establecer Contraseña',
			proteccion_datos: 'Protección de datos',
			visor_oferta: "Ver como alumno",
			fichaProgramaActivo: "Programas activos",
			solicitudCambioPracticas: "Solicitud cambio de prácticas",
			solicitudesEducacion: "Solicitudes vacantes educación",
			subirConvenioFirmado: 'Subir convenio firmado',
			generarNuevoConvenio: 'Nuevo convenio de Colaboración',
			ayuda: 'Ayuda',
			formulario_incorporacion: 'Formulario de incorporación'
		},
		ficha_oferta: {
			texto_programa_anadido: "Tienes este programa añadido a tu lista de programas informáticos"
		},
		formulario: {
			nombre: "Nombre",
			nombre_apellidos: "Nombre y apellidos",
			apellidos: "Apellidos",
			email: "Email",
			mensaje: "Mensaje",
			fecha_nacimiento: "Fecha de nacimiento",
			dia: "Día",
			mes: "Mes",
			anyo: "Año",
			area_interes: "Área de su interés",
			trabaja_actualmente: "¿Trabaja actualmente?",
			si: "Si",
			no: "No",
			carta_presentacion: "Carta de presentacion",
			meses: {
				Enero: "Enero",
				Febrero: "Febrero",
				Marzo: "Marzo",
				Abril: "Abril",
				Mayo: "Mayo",
				Junio: "Junio",
				Julio: "Julio",
				Agosto: "Agosto",
				Septiembre: "Septiembre",
				Octubre: "Octubre",
				Noviembre: "Noviembre",
				Diciembre: "Diciembre"
			},
			archivo_adjunto: "Adjuntar archivo",
			adjuntar_cv: "Adjuntar CV",
			introduce_mail: "Introduce tu email",
			pais: "País",
			telefono: "Teléfono",
			he_leido: "He leído y acepto la",
			y_acepto: "política de privacidad",
			enviar: "Enviar",
			enviado: "Enviado",
		},
		meses: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
		prelogin: {
			bienvenido: 'Acceso al Portal',
			selecciona_perfil: 'Selecciona tu perfil para consultar, publicar o gestionar prácticas académicas o formación en centros de trabajo.',
			usuarios: {
				estudiantes: 'Estudiantes',
				antiguos: "Alumni",
				empresas: 'Empresas'
			}
		},
		login: {
			iniciar_sesion: 'Iniciar sesión',
			acceder: 'Acceder',
			email: "Email",
			error_mail: "Por favor, indica tu email para iniciar sesión en el portal.",
			contrasena: "Contraseña",
			repetir_contrasena: "Repetir Contraseña",
			contrasena_olvidada: "He olvidado mi contraseña",
			introduce_email: 'Introduce tu email',
			email_mal: 'El email está mal formado',
			recuperar_pass: 'Recuperar mi contraseña',
			aun_no_registrado: "¿Aún no estas registrado/a?",
			alta_nueva_empresa: "Alta de nueva empresa",
			acceder_SSO: "ACCEDER SSO UNIVERSIDAD",
			indica_mail: "Por favor, indica tu <strong>{{$t('oferta.email')}}</strong> para iniciar sesión en el portal.",
			selecciona_empresa: "Por favor, selecciona la empresa con la que quieres iniciar sesión.",
			telefono_1 : "Teléfono",
			email_generico_empresa : "Email genérico empresa ",
			telefono_generico_empresa : "Teléfono genérico empresa ",
			popup_rgpd: {
				titulo: 'INFORMACIÓN AMPLIADA',
				detalle: 'Si necesitas ampliar información más detallada, puedes acceder a la Política de Protección de Datos en ',
				enlace: 'este enlace.',
				boton: 'Consiento, acceder'
			},
			restablecer_pass: {
				titulo: 'Sigue los pasos para restablecer tu contraseña',
				intro: 'La contraseña debe contener al menos 8 caracteres y un numero.',
				guardar: 'Guardar'
			},
			seteo_pass: {
				titulo: 'Sigue los pasos para establecer tu contraseña',
				intro: 'La contraseña debe contener al menos 8 caracteres y un numero.',
				guardar: 'Guardar'
			}
		},
		registro: {
			encabezado: 'Completa el formulario a continuación para darte de alta en el sistema:',
			datos_usuario: "Datos del usuario de empresa",
			datos_personales: "Datos personales",
			nombre: "Nombre",
			apellidos: "Apellidos",
			DNI: "DNI/NIF/NIE",
			CIF: "CIF de la empresa",
			puesto: "Puesto / Cargo",
			departamento: "Departamento",
			telefono_1: "Teléfono 1",
			telefono_2: "Teléfono 2",
			email: "Email",
			sede: "Sede por defecto",
			cargo: "Cargo",
			idioma: "Idioma preferido de comunicación",
			tipo_contacto: "Tipo de Contacto",
			contrasena: "Contraseña",
			repetir_contrasena: "Repetir Contraseña",
			direccion: "Dirección",
			pais: "País",
			selecciona_pais: "-selecciona un país-",
			provincia: "Provincia",
			selecciona_provincia: "-Selecciona una provincia-",
			localidad: "Localidad",
			selecciona_localidad: "-Selecciona una localidad-",
			direccion: "Dirección",
			direccion_empresa: "Dirección Empresa",
			cp: "Código Postal",
			titulo_2: "A continuación introduce los datos de tu empresa para darte de alta en el sistema:",
			anadir_imagen: "Haz click para añadir la imagen",
			autorizar_logo: "Autorizar uso del logo",
			nombre_fiscal: "Nombre fiscal o Razón social",
			nombre_comercial: "Nombre comercial",
			tipo_sociedad: 'Tipo de Sociedad',
			selecciona_tipo_sociedad: "-Selecciona tipo de sociedad-",
			tipo_empresa: "Tipo de Empresa",
			privada: "Privada",
			publica: "Pública",
			startup: "Startup",
			eliminar: "Eliminar",
			descripcion: "Descripción",
			si: "Sí",
			no: "No",
			sector: "Sector",
			selecciona_sector: "-Selecciona un sector-",
			otro_sector: "Otro Sector",
			numero_empleados: "Número de empleados",
			selecciona_empleados: "-Selecciona un rango-",
			web: "Web",
			iban: "Nº cuenta IBAN (cuenta bancaria europea)",
			descripcion_empresa: "Descripción de la empresa",
			telefono: "Teléfono",
			CP : "Código Postal",
			firmante: {
				titulo: "A continuación introduce los datos del firmante que firmará los convenios:",
				nombre: "Nombre del firmante",
				apellidos: "Apellidos del firmante",
				email: "Email del firmante",
				dni: "DNI del firmante",
				cargo: "Cargo del firmante",
				telefono: "Teléfono"
			},
			envio_facturas: {
				titulo: "Dirección envío de facturas",
				titulo_2: "Dirección de facturación"
			},
			anadir_direccion: "Añadir nueva dirección de facturación",
			perfil_sectorial: "Sector de experiencia",
			sector_actividad: "Sector de actividad",
			selecciona_sector_actividad: "-Selecciona un sector-",
			rango: "Rango de facturación",
			selecciona_rango: "-Selecciona un rango-",
			numero_empleados: "Número de empleados",
			selecciona_numero_empleados: "-Selecciona un rango-",
			anyo_fundacion: "Año de fundación",
			politica_1: "He leído y acepto la ",
			politica_2: "política de privacidad",
			nuevo_contacto_titulo: "Datos del nuevo contacto de gestión",
			anadir_contacto: "Añadir contacto",
			nueva_cuenta_fiscal: "Datos de la cuenta nueva fiscal",
			domicilio_fiscal: "Domicilio Fiscal",
			poblacion: "Población",
			requiere_envio_postal: "Requiere envío postal facturas",
			domicilio_postal: "Domicilio para el envio postal de facturas",
			anadir_cuenta: "Añadir cuenta",
			datos_firmante: "Datos del firmante",

		},
		mi_practica: {
			subir_documentacion: "Subir documentación",
			descargar_anexo: "Descargar Anexo Firmado",
			descargar_certificado: "Descargar certificado de realización de prácticas",
			descargar_poliza: "Descargar póliza del seguro",
			titulo_practicas: "Para poder incorporarte a la realización de estas prácticas es necesario:",
			pagar_creditos: "Pagar los créditos que se van a reconocer.",
			descarga: "Descarga",
			aqui: "aquí",
			documento_pago: "el documento de Carta de Pago con la información de cantidades debidas e instrucciones.",
			contratar_poliza: "Contratar una póliza de accidentes que te cubra estas prácticas",
			puedes_contratar: "Puedes contratar cualquier póliza de seguro, si lo deseas puedes contratar online",
			mensaje_documentos: "Una vez tengas <strong>listos</strong> los documentos, por favor <strong>digitalízalos y adjúntalos</strong> a continuación. Revisaremos que son válidos antes de firmar el contrato con la empresa.",
			digitaliza_documentos: "Una vez tengas <strong>listo</strong> el documento, por favor <strong>digitalízalo y adjúntalo</strong> a continuación. Revisaremos que es válido antes de firmar el contrato con la empresa.",
			adjuntar_pago: "Adjuntar resguardo de pago",
			adjuntar_seguro: "Adjuntar póliza de seguro",
			descarga_ficheros: "Descarga los siguientes ficheros, firmalos y adjuntalos de nuevo.",
			enviar: "Enviar"
		},
		mis_practicas: {
			titulo: "En esta sección encontrarás toda la documentación referente a tus prácticas.",
			zero_1: "No hay ninguna práctica o documentación de prácticas para mostrar. En caso de duda, por favor",
			zero_2: "contacta con nosotros"
		},
		cambio_password: {
			titulo: "Cambiar contraseña",
			titulo_candidato: "¿Deseas cambiar tu contraseña?",
			contrasena_actual: "Contraseña actual",
			nueva_contrasena: "Nueva Contraseña",
			repetir_contrasena: "Repetir nueva Contraseña"
		},
		guia_orientacion: {
			titulo: "A continuación ponemos a tu disposición documentos en relación con tus prácticas o empleo, consejos y buenas prácticas que pueden ser de tu interés.",
			zero: "No hay guias de orientación"
		},
		mi_empresa: {
			intro: {
				cuerpo: 'Se muestran a continuación los datos principales de su empresa. Si alguno no es correcto, o necesita acceder, corregir, eliminar cualquier detalle de su información.',
				porfavor: 'Por favor, ',
				contacte: 'contacte con nosotros.'
			},
			datos_empresa: "Datos de la empresa",
		},
		candidaturas_options: {
			aceptar: "Aceptar postulación",
			rechazar: "Rechazar postulación",
			motivos_rechazo: "Motivos del rechazo",
			selecciona_motivo: "- Selecciona un motivo de rechazo -",
			rechazar_preinscripcion: "Rechazar pre-postulación",
		},
		oferta: {
			intro_editor: "Completa el formulario a continuación para crear una vacante nueva:",
			tipo_oferta: "Tipo de vacante",
			numero_plazas: "Número de plazas",
			experiencia: "Experiencia",
			experiencia_deseable: "Experiencia deseable",
			horario: "Horario",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de finalización",
			tipo_contrato: "Tipo de contrato",
			salario: "Salario",
			creditos: "Créditos superados",
			otras_remuneraciones: "Otras remuneraciones",
			pais: "País",
			poblacion: "Población",
			poblacion_only: "Población",
			provincia: "Estado / Provincia / Región",
			sector: "Sector",
			area_funcional: "Área funcional",
			sede: "Sede/campus",
			beca: "Beca mensual",
			descripcion_puesto: "Descripción del puesto",
			tarea: "Tarea",
			otras_tareas: "Otras tareas",
			programa_practicas: "Programa de prácticas",
			aviso_programa: "Importante consultar para comprobar requisitos obligatorios",
			enlace_inscripcion: "Enlace de inscripción",
			ir_enlace: 'Ir al enlace',
			idiomas: "Idiomas",
			anadir_idiomas: "Añadir Idiomas",
			empleo: "Empleo",
			practicas: "Prácticas",
			certificacion: "- Certificación mínima requerida:",
			requerido: "- Requerido",
			estudios_obligatorios: "Estudios obligatorios",
			areas: "Áreas",
			estudios_deseables: "Estudios deseables",
			requisitos_obligatorios: "Requisitos obligatorios",
			etiquetas: "Etiquetas",
			otros_obligatorios: "Otros obligatorios",
			edad_maxima: "Edad maxima",
			salario_maximo: "Salario Máximo",
			intereses_deseables: "Intereses deseables",
			intereses_obligatorios: "Intereses obligatorios",
			intereses_seleccionados: "Intereses seleccionados",
			competencias_obligatorias: "Competencias obligatorias",
			competencias_seleccionadas: "Competencias seleccionadas",
			paises_nacionalidad_obigatorios: "Paises de Nacionalidad obligatorios",
			paises_residencia_obligatorios: "Paises de Residencia obligatorios",
			provincia_residencia_obligatorios: "Estado / Provincia / Región de Residencia obligatorios",
			paises_seleccionados: "Paises seleccionados",
			provincias_seleccionados: "Estado / Provincia / Región seleccionadas",
			coche_propio: "Automóvil propio",
			obligatorio_quest: "¿Obligatorio?",
			carnet_conducir: "Licencia de conducir",
			disponible_extranjero: "Disponible para trabajar en el extranjero",
			disponible_residencia: "Disponible para cambio de residencia",
			trabajando_actualmente: "Trabajando actualmente",
			requisitos_deseables: "Requisitos deseables",
			otros_requisitos_deseables: "Otros Requisitos deseables",
			otros_requisitos_obligatorios: "Otros requisitos obligatorios",
			motivos_exclusion: "Motivos de exclusión",
			competencias_deseables: "Competencias deseables",
			paises_nacionalidad_deseables: "Paises de Nacionalidad deseables",
			paises_residencia_deseables: "Paises de Residencia deseables",
			provincia_residencia_deseables: "Estado / Provincia / Región de Residencia deseables",
			programas_informaticos: "Programas informáticos",
			programas_informaticos_deseables: "Programas informáticos deseables",
			documentos_requeridos: "Documentos requeridos",
			documentos: "Documentos",
			marca_documentos: "Marca los documentos que deben aportar los candidatos/as.",
			areas: "Áreas",
			marca_areas: "Marca las áreas a las que deben pertenecer los candidatos/as.",
			alguna_area_seleccionada: "Debe haber alguna área seleccionada para guardar la vacante.",
			anadir_otro_documento: "Añadir otro tipo de documento",
			nombre_documento_candidato: "Nombre del documento a aportar por el candidato",
			inscribirme: "Inscribirme",
			desinscribirme: "Retirar mi postulación",
			ya_inscrito: "ya estas inscrito",
			cancelar_inscripcion: "Cancelar inscripción",
			atencion: "¡Atención!",
			tramitar_inscripcion: "Para tramitar tu inscripción en esta vacante debes presentar tu postulación en la web de la empresa ofertante.",
			acceder: "Para acceder",
			pincha_aqui: "da clic aquí.",
			especialidad: "Especialidad",
			estado: "Estado",
			datos_practica: "Datos de la práctica",
			paso_4: "Paso 4 de 4",
			tareas_a_desarrollar: "Tareas a desarrollar",
			horario: "Horario",
			horas_dia: "Horas al día",
			remuneracion: "Remuneración",
			otros_beneficios: "Otros beneficios",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",
			fecha_alta: "Fecha Alta",
			duracion_meses: "Duración (en meses)",
			dedicacion: "Dedicación (% jornada)",
			departamento: "Departamento",
			modalidad: "Modalidad",
			numero_dias_semana: "Numero de días por semana",
			dias_semana: "Días de la semana",
			vinculado_tfg: "Vinculado a Tesis / Proyecto final",
			nombre_tfg: "Nombre TFG",
			tutor_tfg: "Tutor/a de Tesis / Proyecto final",
			solicitante: "Solicitante del servicio",
			centro_practicas: "Centro de prácticas",
			n_pedido: "Nº de pedido (si lo requiere)",
			observaciones: "Observaciones",
			direccion: "Dirección",
			nombre_tutor_uni: "Nombre y apellidos del tutor de la Universidad",
			datos_tutor_empresa: "Datos del tutor en la empresa",
			nombre: "Nombre",
			apellidos: "Apellidos",
			email: "Email",
			telefono: "Teléfono",
			cargo: "Cargo",
			dni: "DNI",
			titulacion_especialidad: "Carrera o especialidad",
			titulacion: "Carrera",
			selecciona: "-Seleccionar-",
			nombre_oferta: "Nombre de la vacante",
			numero_plazas: "Número de plazas",
			experiencia_requerida: "Experiencia requerida",
			experiencia_deseable: "Experiencia deseable",
			opciones_publicacion: "Opciones de publicación",
			url_inscripcion: "URL inscripción empresa",
			candidato_preferido: "Candidato/a preferido",
			datos_realizacion: "Datos de realización de la práctica",
			conocimientos_especificos: "Conocimientos especificos",
			formacion_adquirida: "Formación adquirida",
			seguimiento_previsto: "Seguimiento previsto",
			empresa_destino: "Empresa destino (solamente si es vacante de gestora/consultora ETT)",
			datos_tutor: "Datos del tutor/a de la empresa",
			para_estudiantes_ultimo_ano: "Para estudiantes de último año",
			para_perfil_no_universitario: "Para perfil no universitario",
			activo_quest: "¿Activo?",
			ano_promo_maximo: "Año de promoción máximo",
			enviar_quest: "¿Enviar?",
			candidato_leer: "Candidato/a por leer",
			candidatos_leer: "Candidatos/as por leer",
			candidato_total: "Candidato/a en total",
			candidatos_total: "Candidatos/as en total",
			ver_detalles: "Ver detalles",
			con_practicas: "- Con prácticas asignadas",
			fecha_caducidad: "Fecha de caducidad",
			buscar_mas_programa: "Busca más programas informáticos",
			programas_elegidos: "Programas informáticos elegidos",
			sin_programas: "Sin programas informáticos especificados",
			selecciona_idioma: "Selecciona un idioma",
			escribe_idioma: "Escribe aquí el idioma",
			idioma: "Idioma",
			indica_certificacion: "Indica aquí la certificación o nivel mínimo requerido",
			titulaciones: "Carreras",
			requeridas: "requeridas",
			deseables: "deseables",
			a_las_que: "a las que se dirige la vacante",
			notaMultiSelectTitulaciones: "Puede incluir una o varias carreras, dando clic sobre el nombre de aquella/s de su interés y volviendo a desplegar el listado. Verá todas las que ha seleccionado marcadas en color.",
			titulacion_seleccionada: "carrera seleccionada",
			titulaciones_seleccionadas: "carreras seleccionadas",
			nivel: "Nivel",
			areas: "Áreas",
			cualquier_area: "Cualquier área",
			ninguna_titulacion: "Ninguna carrera concuerda con el filtro de nivel indicado.",
			eliminar_todas: "Eliminar todas",
			areas_dirige: "Áreas a las que se dirige la vacante",
			titulaciones_dirige: "Carreras a las que se dirige la vacante",
			selecciona_titulaciones: "Selecciona las carreras en el listado de la izquierda",
			cumplimentar: "Completar solo en el caso de que lo considere información relevante para los candidatos/as.",
			tipo_estudios: "Tipo de estudios",
			seleccione_izquierda: "Selecciona las áreas en el listado de la izquierda.",
			seleccione_algun_nivel: "Seleccione algún nivel para cargar las áreas asociadas",
			especialidad_titulacion: "Especialidad o carrera/s",
			puesto_trabajo: 'Puesto de trabajo',
			motivo_rechazo: "Motivo de rechazo",
			ayuda_estudio: "Ayuda al estudio",
			tutor_empresa: "Tutor de la empresa",
			nombre_tutor: "Nombre del tutor empresa",
			apellidos_tutor: "Apellidos del tutor empresa",
			email_tutor: "Email del tutor empresa",
			telefono_tutor: "Teléfono del tutor empresa",
			cargo_tutor: "Cargo del tutor empresa",
			titulacion_tutor: "Carrera del tutor empresa",
			departamento_tutor: "Departamento del tutor empresa",
			dni_tutor: "DNI del tutor empresa",
			no_definido: "No definido",
			candidatos: "Candidatos/as",
			exportar: "Exportar",
			no_hay_candidatos: "No hay candidatos/as en esta vacante",
			mas: "más",
			menos: "menos",
			empresa_destino_simple: "Empresa Destino",
			tipo_formacion: "Tipo de formación",
			niveles: "Niveles",
			areas: "Áreas",
			para_estudiantes_ultimo_curso: "Para estudiantes de último curso",
			sucursal: "Sucursal",
			mandar_a_validar: "Mandar a validar",
			estimacion_total_horas: "Estimación total horas"
		},
		filtro_oferta: {
			buscar_nombre: "Busca por nombre del puesto",
			buscar_localizacion: "Busca por localización",
			buscar_titulacion: "Busca por carrera",
			buscar_puesto: "Busca por nombre del puesto",
			filtro_avanzado: "Filtro Avanzado",
			cerrar: "Cerrar",
			fecha_publicacion: "Fecha publicación",
			fecha_inicio_previsa: "Fecha de inicio de práctica prevista",
			fecha_inicio: "Fecha de inicio",
			filtrado_etiqueta: "Filtrado por etiquetas",
			omitir_inscritos: "Omitir ya inscritos",
			oferta_tfg: "Vacante TFG/TFM",
			ofertas_internacional: "Vacante internacional",
			ofertas_cv: "Vacantes que encajan con mi perfil/cv",
			busquedas_guardadas: "Búsquedas guardadas",
			guardar_busqueda: "Guardar búsqueda",
			borrar_filtros: "BORRAR FILTROS",
			ver: "Ver",
			fecha: "Fecha",
			se_han_encontrado: "Se han encontrado",
			introduce_nombre_busqueda: "Introduce el nombre de la búsqueda",
			sobreescribe_existente: "ó sobreescribe una existente",
			selecciona_busqueda: "Selecciona una búsqueda",
			ver_historico: "Ver histórico de vacantes",
			ver_actuales: "Ver vacantes actuales",
			crear_oferta: "CREAR VACANTE",
			historico_ofertas: "Histórico de vacantes",
			no_hay_ofertas: "No hay vacantes coincidentes con tu búsqueda",
			solo_con_candidatos: "Sólo vacantes con candidatos/as sin leer",
			tienen_candidatos: "Tienen candidatos/as",
			caduca_pronto: "Caducan pronto",
			no_leidos: "Solo no leidos"
		},
		popup_confirmacion: {
			recuerda: "¡Recuerda!",
			titulo: "Asegúrate de que los datos de tu perfil están actualizados antes de postularte a una vacante.",
			actualiza: "Actualízalo dando clic",
			aqui: "aquí.",
			confirma_titulo: "Por favor confirma que quieres ser candidato/a en esta vacante.",
			atencion: "¡Atención!",
			necesitamos_anadir: "Necesitamos que añadas los siguientes documentos para poder inscribirte a la vacante.",
			url_documento: "URL del documento",
			por_favor_adjunta: "Por favor, adjunta un archivo o url",
			alumnos_master: "Los alumnos de máster de 2 años de duración deben tener al menos el 50% de los créditos aprobados, a fecha de inicio de realización de las prácticas, para poder realizarlas. ¿Eres alumno de máster de duración inferior a 2 años, o has superado el 50% de los créditos?"
		},
		encuestas_obligatorias: {
			titulo: "Encuestas Obligatorias",
			cuerpo: "Por favor, antes de continuar, responda estas encuestas",
			no_puedes: "No puedes acceder al portal hasta que no hayas contestado las encuestas obligatorias. Si no deseas responder en este momento, puedes cerrar tu sesión.",
		},
		header: {
			hola: "Hola, ",
			oferta_practicas: "Buscar vacantes de prácticas",
			oferta_empleo: "Buscar vacantes de empleo",
			propuesta_practicas: "Propuesta de prácticas",
			candidaturas: "Mis postulaciones",
			practicas: "Mis prácticas",
			programas: "Programas",
			encuestas: "Encuestas",
			eventos: "Eventos",
			mi_cv: "Mi CV",
			guias_orientacion: "Guías Orientación",
			mis_ofertas: "Mis vacantes",
			nueva_oferta: "Nueva vacante",
			solicitar_cambio_practicas: "Solicitar cambio de prácticas",
			documentacion: "Documentación",
			solicitudes_practicas_educacion: "Solicitudes prácticas educación",
			encuestas: "Encuestas",
			mi_empresa: "Mi empresa",
			ayuda: "Ayuda",
			cerrar_sesion: "Cerrar sesión",
			solicitar_baja: "Solicitar baja"
		},
		image_uploader: {
			titulo: "Editar imagen de perfil",
			subtitulo: "Atención: si es posible, suba una imagen de proporciones 1:1. Si sube una imagen alargada u horizontal, puede ajustar el área de corte ampliando o reduciendo la imagen usando su scroll; puede además mover la imagen para ajustar el área de recorte arrastrándola con el ratón.",
		},
		notificaciones: {
			borrar_todo: "Borrar todo",
			importantes: "Importantes",
			otras_notificaciones: "Otras notificaciones",
			no_notificaciones: "No tienes notificaciones pendientes"
		},
		popup_borrar_cuenta: {
			titulo: "¿Desea solicitar la baja del servicio y la supresión de sus datos personales?",
			si: "Sí",
			no: "No"
		},
		popup_pedir_naf: {
			titulo: "¡Atención!",
			subtitulo: "Todos los estudiantes deben aportar su Número de Seguridad Social (NSS o NAF) en su perfil. Debes completar:",
			parrafo1: "1. El campo Nº Seguridad social: en la sección de Datos personales de tu cv.",
			parrafo2: "2. Adjuntar el documento de acreditación del Número de la Seguridad Social en la sección Documentación adjunta, apartado disponible al final de tu cv.",
			pie: "Accede ya para completarlo.",
			ir: "Ir ahora",
		},
		popup_faltan_datos_empresa: {
			atencion: "¡Atención!",
			cuerpo_1: "Faltan datos obligatorios en tu perfil, por favor accede para completarlos.",
			cuerpo_2: "Faltan datos obligatorios en el perfil de tu empresa, por favor accede para completarlos.",
			ir_a_perfil: "Ir a mi Perfil",
			ir_a_empresa: "Ir a Mi empresa"
		},
		popup_datos_personales: {
			atencion: "¡Atención!",
			titulo: "Antes de poder continuar debes completar los siguientes datos obligatorios de tu perfil:",
			ir_a_perfil: "Ir a mi Perfil"
		},
		solicitudes_educacion: {
			titulo: "En esta sección encontrarás la información de los estudiantes que han solicitado la realización de prácticas en su centro.",
			zero: "No hay documentación en estos momentos."
		},
		filtro_candidaturas: {
			buscar_nombre: "Busca por nombre del puesto",
			empleo: "Empleo",
			practicas: "Prácticas",
			filtro_avanzado: "Filtro Avanzado",
			cerrar: "Cerrar",
			estado: "Estado",
			ver: "Ver",
			borrar_filtros: "BORRAR FILTROS",
			estas_en: "Estas en",
			zero: "No hay procesos de selección coincidentes con tu búsqueda"
		},
		documentacion: {
			intro: "En esta sección encontrarás la documentación relacionada con las prácticas que se han realizado en tu empresa.",
			convenio_titulo: "Convenios de colaboración",
			caducado: "(Caducado) -",
			zero_convenio: "Aún no tienes ningún convenio",
			titulo_convenio: "Si lo deseas puedes solicitar y descargar el convenio de colaboración, o aportar el documento ya firmado por tu empresa:",
			nuevo_convenio: "Nuevo convenio",
			subir_convenio: "Subir convenio firmado",
			anexos_practicas: "Anexos de prácticas",
			zero_practicas: "Aún no tienes contenido",
			notas_formativas: "Notas formativas",
			en: "en",
			otros_documentos: "Otros documentos asociados a prácticas",
			zero_documentos: "Aún no tienes ningún documento de prácticas",
			otros_documentos_programas: "Otros documentos asociados a programas",
			zero_documentos_practicas: "Aún no tienes ningún documento asociado a programas",
			documentos_aportados_empresa: "Otros documentos aportados por la empresa",
			no_documentos_anadidos: "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
			anadir_documentacion: "Añadir documentación",
			selecciona_documento: "Selecciona un documento",
			listado_documento: "Listado de documentos",
			otro_tipo_documento: "Otro tipo de documento",
			nombre_documento: "Nombre del documento",
			url_documento: "URL del documento",
		},
		encuestas: {
			titulo: "Encuestas",
			obligatorias: "Para continuar, responde todas las preguntas obligatorias",
			enviar: "Enviar",
			pagina: "Página",
			datos_enviados: "Tus datos han sido enviados",
			muchas_gracias: "¡Muchas gracias!",
			iniciar_sesion: "Inicia sesión con tu usuario",
			empresa: "Empresa",
			candidato: "Candidato",
			usuario: "Usuario",
			contrasena: "Contraseña",
			acceder: "Acceder",
			o: 'ó',
			acceder_anonimamente: "Acceder anonimamente",
			contestar_pregunta: "Debes contestar a esta pregunta para continuar",
			zero: "No hay encuestas disponibles"
		},
		eventos: {
			proximos: "Próximos eventos",
			pasados: "Eventos pasados",
			evento_destacado: "Evento destacado",
			desde: "Desde",
			hasta: "Hasta",
			organizado_por: "Organizado por",
			inscribirse: "Inscribirse",
			inscrito: "Inscrito",
			mas_informacion: "Más información",
			galeria: "Galería de imágenes",
			videos: "Vídeos",
			buscar_localizacion: "Buscar por localización",
			buscar_categoria: "Buscar por categoría",
			buscar_nombre: "Buscar por nombre",
			eventos_pasados: "Eventos ya pasados",
			ver_mas: "Ver más"
		},
		comunicaciones: {
			titulo: "Comunicaciones"
		},
		guias: {
			titulo: "Últimas guías de orientación",
			zero: "No hay guias de orientación"
		},
		ofertas: {
			ultimas_practicas: "Últimas Vacantes de prácticas",
			practicas: "Prácticas",
			ultimas_empleo: "Últimas Vacantes de empleo",
			empleo: "Empleo",
			ofertas: "Vacantes",
			zero_ofertas: "En estos momentos no hay ninguna vacante con visibilidad para tu perfil. En caso de duda, por favor contacta con nosotros.",
			ver_todas: "Ver todas",
			ver_todas_ofertas_actuales: "Ver todas las vacantes de prácticas actuales para tu perfil",

		},
		cv: {
			nivel: "Nivel",
			programa_informatico: "Programa informático",
			certificado: "Certificado",
			sin_nivel: "Sin nivel definido",
			presentacion: "Presentación",
			anadir_presentacion: "Para añadir tu presenctación pulsa",
			aqui: "aquí",
			otros_intereses: "Otros intereses",
			tus_interes: "Tus intereses",
			sin_intereses: "Sin intereses especificados",
			escribe_interes: "Escribe algunas áreas de interés, para comenzar a buscar",
			click_interes: "Haz click sobre el interes, para añadirlo",
			click_cambiar_imagen: "Haz click para cambiar la imagen",
			cambiar_contrasena: "Cambiar contraseña",
			idiomas: "Idiomas",
			idioma: "Idioma",
			sin_idiomas: "Sin idiomas añadidos, pulsa en añadir idioma para añadirlo",
			idioma_obligatorio: "El idioma y el nivel son campos obligatorios para añadir un idioma",
			nivel_no_definido: "Nivel no definido",
			nivel: "Nivel",
			nombre_certificado: "Nombre del certificado",
			estancia_extranjero: "Estancia en el extranjero",
			pais_estancia: "País de estancia",
			motivo_estancia: "Motivo de la estancia",
			duracion_meses: "Duración en meses",
			experiencia_profesional: "Experiencia profesional",
			anadir_nueva_experiencia: "Añadir nueva experiencia",
			sin_experiencia: "Sin experiencia",
			actualidad: "Actualidad",
			puesto: 'Titulo del puesto',

			sector_empresa: "Sector de la empresa",
			area_actividad_puesto: "Área de actividad del puesto",
			tipo_contrato: "Tipo de contrato",
			subtipo_contrato: "Subtipo de contrato",
			ver_adjunto: "Ver adjunto",
			ver_enlace: "Ver enlace",
			duracion: "Duración",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",
			provincia: "Estado / Provincia / Región",
			empresa: "Empresa",
			enlace: "Enlace",
			descripcion_puesto: "Descripción del puesto",
			escribe_descripcion: "Escribe una descripción de las tareas desempeñadas",
			anadir_fichero: "Añadir fichero adjunto",
			adjunto_correctamente: "Archivo adjunto correctamente",
			programas_informaticos: {
				titulo: "Programas informáticos",
				buscar: "Escribe para buscar",
				zero: "No hay programas informáticos añadidos, pulsa en añadir para añadirlos",
				anadir: "Añadir Programa",
			},
			documentacion_adjunta: "Documentación adjunta",
			documentacion_subida: "Documentación subida el",
			no_hay_documentos: "No hay documentos añadidos",
			pulsa_anadir_documentos: ", pulsa en añadir documento para añadirlo",
			anadir_documentacion: "Añadir documentación",
			selecciona_documento: "Selecciona un documento",
			listado_documento: "Listado de documentos",
			otro_tipo_documento: "Otro tipo de documento",
			nombre_documento: "Nombre del documento",
			url_documento: "URL del documento",
			documentacion_privada: "Documentación privada",
			no_documentos: "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
			documentacion_ligada: "Documentación ligada a procesos",
			datos_profesionales: "Datos profesionales",
			visitar: "Visitar",
			indica_link_perfil: "Indica link a tu perfil",
			trabajando_actualmente: "Trabajando actualmente",
			permiso_trabajo: "Permiso de trabajo en la Unión Europea",
			anos_experiencia: "Años de experiencia",
			sin_experiencia: "Sin experiencia",
			disfrutado_erasmus: "He estado en un Programa de intercambio internacional",
			minima_retribucion: "Mínima retribución",
			brutos_anuales: "/ brutos anuales",
			datos_personales: "Datos personales",
			dni: "DNI",
			fecha_nacimiento: "Fecha de nacimiento",
			genero: "Género",
			femenino: "Femenino",
			masculino: "Masculino",
			email_personal: "Email",
			email_estudiante: "Email de estudiante",
			avisos_en_email: "Avisos en el email personal",
			acepta_newsletter: "Acepta newsletter",
			idioma_comunicaciones: "Idioma preferido para las comunicaciones",
			movil: "Movil",
			fijo: "Teléfono fijo",
			direccion_empadronamiento: "Domicilio fiscal / de residencia",
			direccion_actual: "Dirección actual",
			direccion: "Dirección",
			iban: "Nº cuenta IBAN (cuenta bancaria europea)",
			seguridad_social: "Nº Seguridad social",
			pais_nacionalidad: "País de nacionalidad",
			pais_segunda_nacionalidad: "País de segunda nacionalidad",
			provincia_nacimiento: "Estado / Provincia / Región de nacimiento",
			provincia: "Estado / Provincia / Región",
			lugar_nacimiento: "Lugar de nacimiento",
			discapacidad: "Discapacidad superior al 33%",
			deseo_recibir_comunicaciones: "Deseo recibir comunicaciones relacionadas con orientación y servicios relacionados con la formación superior y la UIB:",
			nombre: "Nombre",
			primer_apellido: "Primer apellido",
			segundo_apellido: "Segundo apellido",
			tipo_identificacion: "Tipo de identificación",
			documento_identidad: "Documento de identidad",
			buscar: "Escribe para buscar",
			cp: "Código Postal",
			pais: "País",
			localidad: "Localidad",
			tipo_via: "Tipo de vía",
			numero: "Número",
			piso: "Piso",
			puerta: "Nº  Casa / Departamento / Oficina",
			notas: "Notas",
			datos_academicos: "Datos académicos",
			formacion_complementaria: "Formación complementaria",
			anadir_titulacion: "Añadir nueva carrera",
			complementaria: "complementaria",
			centro: "Centro",
			tipo: "Tipo",
			nota: "Nota",
			rama_ensenanza: "Rama de la enseñanza",
			duracion: "Duración",
			actual: "Actual",
			si: "Sí",
			no: "No",
			titulo: "Titulo",
			universidad: "Universidad/Lugar de estudios",
			calificacion: "Calificación",
			calificacion_media: "Calificación media del titulo",
			formacionAcademica: "Formación académica",
			horas: "Horas",
			ambito: "Ambito de la enseñanza",
			selecciona_tipo: "- Selecciona un tipo -",
			certificacion: "Certificación",
			tienes_cerfificacion: "¿Tienes certificación?",
			competencias_profesionales: "Competencias profesionales",
			tus_competencias: "Tus competencias",
			sin_competencias: "Sin competencias profesionales especificadas",
			solicitar_sesion: "Puedes solicitar una sesión gratuita de orientación con DOIP UIB.",
			datos_interes: "Datos de interés",
			competencias: "Competencias",
			busqueda_activa_practicas: "Búsqueda activa de prácticas",
			busqueda_activa_empleo: "Búsqueda activa de empleo",
			disponible_extranjero: "Disponible para trabajar en el extranjero",
			permiso_conducir: "Permiso de conducir",
			disponible_cambio_residencia: "Disponible para cambio de residencia",
			coche_propio: "Vehículo propio",
			disponible_viajar: "Disponible para viajar",
			discapacidad_certificada: "Discapacidad certificada",
			observaciones: "Observaciones",
			carnet_moto: "Licencia para conducir",
			moto_propia: "Moto propia",
			disponibilidad_jornadas: "Disponilidad de horario",
			periodo_preferencia_practicas: "Periodo preferencia de prácticas",
			selecciona: "Selecciona",

		},
		addtitulacion: {
			titulo: "Carreras a las que se dirige la vacante",
			seleccione_areas: "Seleccione área/s para filtrar carreras",
			borrar_areas: "Borrar todas las áreas",
			cualquier_area: "Cualquier área",
			escriba_aqui: "Escriba aquí para filtrar el listado de carreras a continuación",
			selecciona_titulacion: "Seleccione la carrera/s a la/s que se dirige la vacante haciendo clic sobre ella/s",
			ver_titulaciones: "Ver carreras de licenciatura",
			listadas: "listadas",
			listados: "listados",
			cualquier_titulacion: "Cualquiera de estas carreras de licenciatura",
			ver_titulaciones_postgrado: "Ver carreras de postgrado",
			cualquier_titulacion_postgrado: "Cualquiera de estas carreras de postgrado",
			ver_titulaciones_propio: "Ver carreras de Título propio",
			cualquier_titulacion_propio: "Cualquiera de estos títulos propios",
			lo_sentimos: "Lo sentimos no se han encontrado carreras que coincidan con la búsqueda",
			listado_titulaciones_seleccionadas: "Listado de carreras seleccionadas",
			eliminar_titulaciones: "Eliminar todas las carreras seleccionadas"
		},
		candidato: {
			nuevo: "Nuevo",
			cambiar_estado: "Cambiar estado",
			ver_cv: "Ver CV",
			detalles: "Detalles del candidato/a",
			selecciona_estado: "Selecciona un estado",
			seleccione_motivo: "Por favor seleccione el motivo de rechazo del candidato/a.",
			cambio_estado: "Cambio de estado",
			descargar_cv: "Descargar CV",
			cumplimentar_formulario_incorporacion: "Completar Formulario de Incorporación"

		},
		cambio_practicas: {
			identifica: "Identifica el alumno/a del que solicitan realizar prórroga o variación de sus condiciones de prácticas.",
			alumno: "Alumno",
			selecciona_oferta: "Selecciona la vacante",
			no_practicas: "Aún no tienes ninguna práctica sobre la que puedas solicitar un cambio.",
			alumno: "Alumno/a",
			selecciona_alumno: "Selecciona el alumno/a",
			detalles: "Detalles de la modificación",
			tipo_modificacion: "Tipo de modificación",
			selecciona_modificacion: "-Selecciona la modificación-",
			otros_detalles: "Otros detalles",
			adjunto: "Adjunto",
			solicitar_cambio: "Solicitar cambio"
		},
		formulario_incorporacion: {
			formularioYaCumplimentado: "Este formulario de incorporación ya ha sido completado y el alumno ha sido seleccionado.",
			encabezado: "Rellena el formulario de incorporación para completar la postulación del alumno y pasarla a seleccionado.",
			datos_departamento_acogida: "Datos del departamento asignado",
			nombre_departamento_acogida: "Nombre del departamento asignado",
			responsable_departamento_acogida: "Responsable del Departamento asignado",

			datos_empresa_institucion: "Datos de la Empresa/Institución:",
			CIF: "CIF",
			razon_social: "Razón Social",
			domicilio_social: "Dirección legal de la empresa",
			cp: "C.P.",
			localidad: "Localidad",
			selecciona_localidad: "-Selecciona una localidad-",
			provincia: "Estado / Provincia / Región",
			selecciona_provincia: "-Selecciona una provincia-",
			sector_empresa: "Sector de la Empresa",
			selecciona_sector: "-Seleccionau un sector-",
			area_funcional: "Area funcional",
			selecciona_area_funcional: "-Selecciona una area funcional-",
			descripcion_actividad_empresa: "Breve descripción de la actividad a la que se dedica la Empresa",

			persona_de_contacto: "Persona de contacto",
			contacto_nombre_apellidos: "Nombre y apellidos",
			contacto_cargo_departamento: "Cargo/Departamento",
			contacto_email: "E-mail",
			contacto_num_telefono: "Nº de Teléfono",

			persona_firmante_anexo_convenio: "Persona firmante del Anexo",
			persona_firmante_convenio_empresa: "Persona firmante del convenio empresa",
			firmante_nombre_apellidos: "Nombre y apellidos",
			firmante_nombre: "Nombre",
			firmante_apellidos: "Apellidos",
			firmante_cargo_departamento: "Cargo/Departamento",
			firmante_email: "E-mail",
			firmante_dni: "DNI",

			datos_alumno: "Datos del Alumno",
			alumno_dni: "DNI",
			alumno_nombre_apellidos: "Nombre y apellidos",
			alumno_titulacion: "Carrera",
			alumno_curso_estudios: "Curso Estudios",

			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",

			datos_periodo_practicas: "Datos sobre el Periodo de Prácticas",
			fecha_comienzo_practicas: "Fecha de comienzo de prácticas",
			fecha_finalizacion_practicas: "Fecha de finalización de prácticas",
			
			lugar_realizacion_practicas: "Lugar de realización de las prácticas",
			sucursal: "Sucursal",
			selecciona_sucursal: "-Selecciona una sucursal-",

			datos_tutor_empresa: "Datos del tutor en la empresa",
			tutor_nombre: "Nombre",
			tutor_apellidos: "Apellidos",
			tutor_cargo: "Cargo en Empresa",
			tutor_email: "E-mail",
			tutor_departamento_seccion: "Departamento o Sección",

			horario_trabajo_sugerido_empresa: "Horario de trabajo sugerido por la empresa",
			num_dias_semana: "Número de días a la semana",
			num_horas_dia: "Número de horas al día",
			estimacion_horas_periodo: "Estimación del cómputo total de horas a realizar",

			datos_de_las_practicas: "Datos de las prácticas",
			retribucion_euros_mes: "Retribución $/USD brutos/mes",
			descripcion_actividad: "Descripción detallada de la actividad a realizar por el alumno (imprescindible para valorar y aprobar su idoneidad)",
			descripcion_competencias: "Descripción de las competencias básicas, genéricas y/o específicas que debe adquirir el alumno durante la realización de las Prácticas (imprescindible para valorar y aprobar su idoneidad)",
		}
	},
	en: {
		enlaces: {
			actualidad: '/news',
			sala_de_prensa: "/press-room",
			contacto: "/contact",
			trabaja_con_nosotros: "/work-with-us",
			politica_privacidad: "/privacy-policy",
			politica_cookies: "/cookies-policy",
		}
	},
	cat: {
		guardar: "Desar",
		volver: "< Tornar",
		sin_definir: "Sense definir",
		guardar_datos: "Desar les dades",
		cancelar: "Cancel·lar",
		confirmar: "Confirmar",
		eliminar: "Eliminar",
		aceptar: "Acceptar",
		rechazar: "Rebutjar",
		comenzar: "Començar",
		cerrar_sesion: "Tancar sessió",
		ver_menos: "Veure menys",
		ver_mas: "Veure més",
		inicio: "Inici",
		ver_detalles: "Veure detalls",
		guardar: "Desar",
		editar: "Editar",
		anadir: "Afegir",
		enviar: "Enviar",
		requerido: "Requerit",
		revisar: "Revisar",
		editar_oferta: "Editar oferta",
		duplicar_oferta: "Duplicar oferta",
		cerrar_oferta: "Tancar oferta",
		eliminar_oferta: "Elimina oferta",
		ver_como_candidato: "Ver como candidato",
		practicas: "Pràctiques",
		empleo: "Ocupació",
		ver: "Veure",
		enlaces: {
			politica_privacidad: "/politica-de-privacidad",
			politica_cookies: "/politica-de-cookies",
			login: "/inici-de-sessio",
			solicitar_cuenta: "/solilicitar-compte",
			registroalumno: "/registre",
			encuestas: '/enquestes',
			encuesta: '/enquesta',
			eventos: '/esdeveniments',
			eventospublico: '/evento-publico',
			documentacion: '/documentacion',
			guiaOrientacion: '/guias-orientacion',
			ofertas_practicas: '/ofertas-practicas',
			ofertas_empleo: '/ofertes-feina',
			cv: '/cv',
			vercv: '/veure-cv',
			mis_candidaturas: '/les-meves-candidatures',
			mis_practicas: '/mis-practicas',
			orientacion: '/orientacion-laboral',
			propuesta_practicas: '/propuesta-practicas',
			propuesta_practicas_empresa: '/propuesta-practicas-empresa',
			programapracticasactivos: '/programas-practicas-activos',
			solicitarcambiopracticas: '/solicitar-cambio-practicas',
			subirconvenio: '/pujar-conveni-signat',
			generarnuevoconvenio: '/nuevo-convenio-colaboracion',
			practicaseducacion: '/solicitudes-practicas-educacion',
			nueva_oferta: '/nova-oferta',
			editar_oferta: '/editar-oferta',
			mi_empresa: '/la-meva-empresa',
			mi_perfil: '/el-meu-perfil',
			mis_ofertas: '/les-meves-ofertes',
			mi_oferta: '/oferta',
			programa_practicas: '/programa-practicas',
			visualizar_oferta: '/visor-oferta',
			restablecer_login: '/restablir-iniciaur-sessio',
			restablecer_candidato: '/restablir-candidat',
			setear_pass: '/establir-inici-de-sessio',
			proteccion_datos: '/proteccion-de-datos',
			acceso_saml: '/acces',
			logout: '/final-de-sessio',
			ayuda: '/ajuda',
		},
		encabezado: {
			home: 'Benvingut/da',
			cv: 'El meu currículum',
			cv_view: 'Currículum del candidato',
			eventos: 'Esdeveniments',
			propuesta_practicas: "Proposta de pràctiques",
			politica_privacidad: "Política de privacitat",
			politica_cookies: "Política de galetes",
			login: "Inici de la sessió",
			solicitar_cuenta: "Nova empresa",
			registro_alumno: "Registre",
			ofertas_practicas: "Llistat d'ofertes de pràctiques",
			ofertas_empleo: "Llistat d'ofertes de feina",
			ficha_oferta_alumno_empleo: "Llistat d'ofertes de feina",
			ficha_oferta_alumno_practicas: "Llistat d'ofertes de pràctiques",
			mis_candidaturas: 'Les meves candidatures',
			mis_practicas: 'Les meves pràctiques',
			encuestas: 'Enquestes',
			orientacion: 'Orientació laboral',
			nueva_oferta: 'Nova oferta',
			editar_oferta: 'Editar oferta',
			mi_empresa: "La meva empresa",
			mi_perfil: "El meu perfil",
			documentacion: 'Documentació',
			guiasOrientacion: "Guies d'orientació",
			documentacion_empresa: 'Documentació',
			documentacion_alumno: 'La meva documentació',
			mis_ofertas: 'Les meves ofertes',
			mi_oferta: 'La meva oferta',
			ficha_oferta_empresa: 'La meva oferta',
			restablecer_login: 'Restablir la contrasenya',
			restablecer_candidato: 'Restablir la contrasenya',
			programapracticasactivos: 'Programes de pràctiques actius',
			setear_pass: 'Establir contrasenya',
			proteccion_datos: 'Protecció de dades',
			visor_oferta: "Ver como alumno",
			fichaProgramaActivo: "Programes actius",
			solicitudCambioPracticas: "Sol·licitud canvi de pràctiques",
			solicitudesEducacion: "Sol·licituds ofertes educació",
			subirConvenioFirmado: 'Pujar conveni signat',
			generarNuevoConvenio: 'Nou conveni de col·laboració',
			ayuda: 'Ajuda',
			formulario_incorporacion: 'Formulari d´incorporació'
		},
		ficha_oferta: {
			texto_programa_anadido: "Teniu aquest programa afegit a la vostra llista de programes informàtics"
		},
		formulario: {
			nombre: "Nom",
			nombre_apellidos: "Nom i cognoms",
			apellidos: "Cognoms",
			email: "Adreça electrònica",
			mensaje: "Missatge",
			fecha_nacimiento: "Data de naixement",
			dia: "Dia",
			mes: "Mes",
			anyo: "Any",
			area_interes: "Àrea del vostre interès",
			trabaja_actualmente: "¿Trabaja actualmente?",
			si: "Sí",
			no: "No",
			carta_presentacion: "Carta de presentació",
			meses: {
				Enero: "Gener",
				Febrer: "Febrer",
				Març: "Març",
				Abril: "Abril",
				Maig: "Maig",
				Juny: "Juny",
				Juliol: "Juliol",
				Agost: "Agost",
				Setembre: "Setembre",
				Octubre: "Octubre",
				Novembre: "Novembre",
				Desembre: "Desembre"
			},
			archivo_adjunto: "Adjuntar fitxer",
			adjuntar_cv: "Adjuntar CV",
			introduce_mail: "Introduïu la vostra adreça electrònica",
			pais: "País",
			telefono: "Telèfon",
			he_leido: "He llegit i accept la",
			y_acepto: "política de privacitat",
			enviar: "Enviar",
			enviado: "Enviat",
		},
		meses: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
		login: {
			iniciar_sesion: "Iniciau la sessió",
			acceder: "Accedir-hi",
			email: "Adreça electrònica",
			error_mail: "Per favor, indicau l'adreça electrònica per entrar",
			contrasena: "Contrasenya",
			repetir_contrasena: "Repetir la contrasenya",
			contrasena_olvidada: "He oblidat la contrasenya",
			introduce_email: "Introduïu la vostra adreça electrònica",
			email_mal: "L'adreça electrònica està mal formada",
			recuperar_pass: "Recuperar la contrasenya",
			aun_no_registrado: "Encara no estàs registrat?",
			acceder_SSO: "ACCEDIR SSO UNIVERSITAT",
			indica_mail: "Per favor, indicau el  <strong>{{$t('oferta.email')}}</strong> para logarte en el portal.",
			selecciona_empresa: "Per favor, Seleccionauu l'empresa amb la qual voleu connectar",
			popup_rgpd: {
				titulo: "INFORMACIÓ AMPLIADA",
				detalle: "Si necessitau informació més detallada, podeu accedir a la Política de Protecció de Dades a",
				enlace: "aquest enllaç",
				boton: "Hi consent, accedir"
			},
			restablecer_pass: {
				titulo: "Seguiu les passes per restablir la contrasenya",
				intro: "La contrasenya ha de contenir almenys 8 caràcters i un número",
				Desar: "Desar"
			},
			seteo_pass: {
				titulo: "Seguiu les passes per establir la contrasenya",
				intro: "La contrasenya ha de contenir almenys 8 caràcters i un número",
				Desar: "Desar"
			}
		},
		registro: {
			encabezado: "Emplenau el formulari a continuació per donar-vos d'alta en el sistema:",
			datos_usuario: "Datos del usuario de empresa",
			datos_personales: "Dades personals",
			nombre: "Nom",
			apellidos: "Cognoms",
			DNI: "DNI/NIF/NIE",
			CIF: "CIF de l'empresa",
			puesto: "Posició / Càrrec",
			departamento: "Departament",
			telefono_1: "Telèfon 1",
			telefono_2: "Telèfon 2",
			email: "Adreça electrònica",
			sede: "vostre per defecte",
			cargo: "Càrrec",
			idioma: "Idioma preferit de comunicació",
			tipo_contacto: "Tipus de contacte",
			contrasena: "Contrasenya",
			repetir_contrasena: "Repetir la contrasenya",
			direccion: "Adreça",
			pais: "País",
			seleccion_pais: "-Seleccionau un país-",
			provincia: "Província",
			seleccion_provincia: "-Seleccionau una província-",
			localidad: "Localitat",
			seleccion_localidad: "-Seleccionau una localitat-",
			direccion: "Adreça",
			direccion_empresa: "Adreça empresa",
			cp: "Codi postal",
			titulo_2: "A continuació, introduïu les dades de la vostra empresa per donar-vos d'alta al sistema:",
			anadir_imagen: "Clicau per afegir la imatge",
			autorizar_logo: "Autorizar uso del logo",
			nombre_fiscal: "Nom fiscal o raó social",
			nombre_comercial: "Nom comercial",
			tipo_sociedad: "Tipus de aocietat",
			seleccion_tipo_sociedad: "-Seleccionau tipus de societat-",
			tipo_empresa: "Tipus d'wmpresa",
			privada: "Privada",
			publica: "Pública",
			startup: "Empresa emergent",
			eliminar: "Eliminar",
			descripcion: "Descripció",
			si: "Sí",
			no: "No",
			sector: "Sector",
			seleccion_sector: "-Seleccionau un sector-",
			otro_sector: "Un altre sector",
			numero_empleados: "Nombre de treballadors",
			seleccion_empleados: "-Seleccionau un rang-",
			web: "Web",
			iban: "Número compte IBAN",
			descripcion_empresa: "Descripció de l'empresa",
			firmante: {
				titulo: "A continuació, introduïu les dades de la persona que signarà els convenis:",
				nombre: "Nom del signant",
				apellidos: "Cognoms del signant",
				email: "Email del firmante",
				dni: "DNI del firmante",
				cargo: "Càrrec del signant",
				telefono: "Telèfon"
			},
			envio_facturas: {
				titulo: "Adreça enviament de factures",
				titulo_2: "Adreça de facturació"
			},
			anadir_direccion: "Afegir nova adreça de facturació",
			perfil_sectorial: "Perfil sectorial",
			sector_actividad: "Sector d'activitat",
			selecciona_sector_actividad: "-Seleccionau un sector-",
			rango: "Rang de facturació",
			selecciona_rango: "-Seleccionau un rang-",
			numero_empleados: "Nombre de treballadors",
			selecciona_numero_empleados: "-Seleccionau un rang-",
			anyo_fundacion: "Any de fundació",
			politica_1: "He llegit i accept la",
			politica_2: "política de privacitat",
			nuevo_contacto_titulo: "Dades del nou contracte de gestió",
			anadir_contacto: "Afegir contacte",
			nueva_cuenta_fiscal: "Dades del compte nou fiscal",
			domicilio_fiscal: "Domicili fiscal",
			poblacion: "Població",
			requiere_envio_postal: "Requereix enviament postal de les factures",
			domicilio_postal: "Domicilio para el envio postal de facturas",
			anadir_cuenta: "Afegir compte",
			datos_firmante: "Datos del firmante",

		},
		mi_practica: {
			subir_documentacion: "Pujar documentació",
			descargar_anexo: "Descarregar annex signat",
			descargar_certificado: "Descarregar certificat de realització de pràctiques",
			descargar_poliza: "Descarregar pòlissa d'assegurança",
			titulo_practicas: "Per poder incorporar-vos a la realització d'aquestes pràctiques és necessari:",
			pagar_creditos: "Pagar els crèdits que es reconeixeran",
			descarga: "Descarregau",
			aqui: "aquí",
			documento_pago: "el document pagament amb la informació de quantitats degudes i instruccions",
			contratar_poliza: "Contractar una pòlissa d'accidents que us cobreixi aquestes pràctiques",
			puedes_contratar: "Podeu contractar qualsevol pòlissa d'assegurança Si ho voleu, podeu contractar-la en línia",
			mensaje_documentos: "Quan tingueu <strong>enllestits</strong> els documents, per favor <strong>digitalitzau-los i adjuntau-los</strong> a continuació Revisarem que són vàlids abans de signar el contracte amb l'empresa",
			digitaliza_documentos: "Quan tingueu  <strong>enllestit</strong> el document, per favor <strong>digitalitzau-lo i adjuntau-lo</strong> a continuació Revisarem que és vàlid abans de signar el contracte amb l'empresa",
			adjuntar_pago: "Adjuntar resguard de pagament",
			adjuntar_seguro: "Adjuntar pòlissa d'assegurança",
			descarga_ficheros: "Descarga los siguientes ficheros, firmalos y adjuntalos de nuevo.",
			enviar: "Enviar"
		},
		mis_practicas: {
			titulo: "En aquesta secció trobareu tota la documentació sobre les vostres pràctiques",
			zero_1: "No hi ha cap pràctica o documentació de pràctiques per mostrar En cas de dubte, per favor",
			zero_2: "Contactau amb nosUn altres"
		},
		cambio_password: {
			titulo: "Canviar contrasenya",
			titulo_candidato: "Voleu canviar la contrasenya?",
			contrasena_actual: "Contrasenya actual",
			nueva_contrasena: "Contrasenya nova",
			repetir_contrasena: "Repetir la nova contrasenya"
		},
		guia_orientacion: {
			titulo: "A continuació, posam a la vostra disposició documents en relació amb les vostres pràctiques o llocs de treball, consells i bones pràctiques que poden ser del vostre interès",
			zero: "No hi ha guies d'orientació"
		},
		mi_empresa: {
			intro: {
				cuerpo: "A continuació, apareixen les dades principals de la vostra empresa Si alguna no és correcte, o necessitau accedir, corregir, eliminar qualsevol detall de la informació",
				porfavor: "Per favor,",
				contacte: "contactau amb nosUn altres"
			},
			datos_empresa: "Dades de l'empresa",
		},
		candidaturas_options: {
			aceptar: "Acceptar inscripció",
			rechazar: "Rebutjar la inscripció",
			motivos_rechazo: "Motius del rebuig",
			Seleccionau_motivo: "- Seleccionau un motiu de rebuig -",
			rechazar_preinscripcion: "Rebutjar la preinscripció",
		},
		oferta: {
			intro_editor: "Emplenau el formulari a continuació per crear una oferta nova:",
			tipo_oferta: "Tipus d'oferta",
			numero_plazas: "Nombre de places",
			experiencia: "Experiència",
			experiencia_deseable: "Experiència desitjable",
			horario: "Horari",
			fecha_inicio: "Data de començament",
			fecha_fin: "Data de finalització",
			tipo_contrato: "Tipus de contracte",
			salario: "Salari",
			otras_remuneraciones: "Altres remuneracions",
			pais: "País",
			poblacion: "Població/Província",
			poblacion_only: "Població",
			provincia: "Província",
			sector: "Sector",
			area_funcional: "Àrea funcional",
			sede: "vostre/campus",
			beca: "Beca mensual",
			descripcion_puesto: "Descripció del lloc",
			tarea: "Tasca",
			otras_tareas: "Altres tasques",
			programa_practicas: "Programa de pràctiques",
			aviso_programa: "Important consultar-ho per comprovar els requisits obligatoris",
			enlace_inscripcion: "Enllaç d'inscripció",
			ir_enlace: "Anar a l'enllaç",
			idiomas: "Idiomes",
			anadir_idiomas: "Añadir Idiomas",
			empleo: "Ocupació",
			practicas: "Pràctiques",
			certificacion: "- Certificació mínima requerida:",
			requerido: "- Requerit",
			estudios_obligatorios: "Estudis obligatoris",
			areas: "Áreas",
			estudios_deseables: "Estudis desitjables",
			requisitos_obligatorios: "Requisits obligatoris",
			etiquetas: "Etiquetes",
			otros_obligatorios: "Altres obligatoris",
			edad_maxima: "Edad maxima",
			salario_maximo: "Salari màxim",
			intereses_deseables: "Interessos desitjables",
			intereses_obligatorios: "Interessos obligatoris",
			intereses_Seleccionaudos: "Interessos Seleccionauts",
			competencias_obligatorias: "Competències obligatòries",
			competencias_Seleccionaudas: "Competències Seleccionaudes",
			paises_nacionalidad_obigatorios: "Paises de Nacionalidad obligatorios",
			paises_residencia_obligatorios: "Paises de Residencia obligatorios",
			provincia_residencia_obligatorios: "Província de residència obligatòria",
			paises_Seleccionaudos: "Paises Seleccionaudos",
			provincias_Seleccionaudos: "Províncies Seleccionaudes",
			coche_propio: "Cotxe propi",
			obligatorio_quest: "Obligatori?",
			carnet_conducir: "Carnet de conduir",
			disponible_extranjero: "Disponibilitat per treballar a l'estranger",
			disponible_residencia: "Disponibilitat per canviar de residència",
			trabajando_actualmente: "Treballant actualment",
			requisitos_deseables: "Requisits desitjables",
			otros_requisitos_deseables: "Altres requisits desitjables",
			otros_requisitos_obligatorios: "Altres requisits obligatoris",
			motivos_exclusion: "Motiu d'exclusió",
			competencias_deseables: "Competències desitjables",
			paises_nacionalidad_deseables: "Paises de Nacionalidad deseables",
			paises_residencia_deseables: "Paises de Residencia deseables",
			provincia_residencia_deseables: "Província de residència desitjable",
			programas_informaticos: "Programes informàtics",
			programas_informaticos_deseables: "Programes informàtics desitjables",
			documentos_requeridos: "Documents requerits",
			documentos: "Documents",
			marca_documentos: "Marcau els documents que han d'aportar els candidats",
			anadir_otro_documento: "Afegir un Un altre tipus de document",
			nombre_documento_candidato: "Nom del document que ha d'aportar el candidat",
			inscribirme: "Inscriure'm",
			desinscribirme: "Desinscriure'm",
			ya_inscrito: "ya estas inscrito",
			cancelar_inscripcion: "Cancel·lar inscripció",
			atencion: "Atenció!",
			tramitar_inscripcion: "Per tramitar la vostra inscripció en aquesta oferta heu de presentar la candidatura a la web de l'empresa oferent",
			acceder: "Per accedir",
			pincha_aqui: "clicau aquí",
			especialidad: "Especialitat",
			estado: "Estat",
			datos_practica: "Dades de la pràctica",
			paso_4: "Passa 4 de 4",
			tareas_a_desarrollar: "Tasques a desenvolupar",
			horario: "Horari",
			horas_dia: "Hores al dia",
			remuneracion: "Remuneració",
			otros_beneficios: "Altres beneficis",
			fecha_inicio: "Data de començament",
			fecha_fin: "Data de finalització",
			fecha_alta: "Data d'alta",
			duracion_meses: "Durada (en mesos)",
			dedicacion: "Dedicació (% jornada)",
			departamento: "Departament",
			modalidad: "Modalitat",
			numero_dias_semana: "Nombre de dies per setmana",
			dias_semana: "Dies de la setmana",
			vinculado_tfg: "Vinculado a TGF",
			nombre_tfg: "Títol del TFG",
			tutor_tfg: "Tutor del TFG",
			solicitante: "Sol·licitant del servei",
			centro_practicas: "Centre de pràctiques",
			n_pedido: "Núm de comanda (si ho requereix)",
			observaciones: "Observacions",
			direccion: "Adreça",
			nombre_tutor_uni: "Nom i cognoms del tutor de la Universitat",
			datos_tutor_empresa: "Datos del tutor en la empresa",
			nombre: "Nom",
			apellidos: "Cognoms",
			email: "Adreça electrònica",
			telefono: "Telèfon",
			cargo: "Càrrec",
			dni: "DNI",
			titulacion_especialidad: "Titulació o especialitat",
			titulacion: "Titulació",
			Seleccionau: "Seleccionau",
			nombre_oferta: "Nom de l'oferta",
			numero_plazas: "Nombre de places",
			experiencia_requerida: "Experiència requerida",
			experiencia_deseable: "Experiència desitjable",
			opciones_publicacion: "Opcions de publicació",
			url_inscripcion: "URL inscripció empresa",
			candidato_preferido: "Candidat preferit",
			datos_realizacion: "Dades de realització de la pràctica",
			conocimientos_especificos: "Coneixements específics",
			formacion_adquirida: "Formació adquirida",
			seguimiento_previsto: "Seguiment previst",
			empresa_destino: "Empresa destí (solament si és oferta de gestora/consultora ETT)",
			datos_tutor: "Datos del tutor/a de la empresa",
			para_estudiantes_ultimo_ano: "Per a estudiants del darrer any",
			para_perfil_no_universitario: "Per a un perfil no universitari",
			activo_quest: "Actiu?",
			ano_promo_maximo: "Any de promoció màxim",
			enviar_quest: "Enviar?",
			candidato_leer: "Candidat per llegir",
			candidatos_leer: "Candidats per llegir",
			candidato_total: "Candidat  en total",
			candidatos_total: "Candidats en total",
			ver_detalles: "Veure detalls",
			con_practicas: "- Amb pràctiques assignades",
			fecha_caducidad: "Data de caducitat",
			buscar_mas_programa: "Cerca més programes informàtics",
			programas_elegidos: "Programes informàtics triats",
			sin_programas: "Sense programes informàtics especificats",
			selecciona_idioma: "Seleccionau un idioma",
			escribe_idioma: "Escriviu aquí l'idioma",
			idioma: "Idiome",
			indica_certificacion: "Indicau aquí la certificació o nivell mínim requerit",
			titulaciones: "Titulacions",
			requerides: "requerides",
			desitjables: "desitjables",
			a_las_que: "a les quals s'adreça l'oferta",
			notaMultiSelectTitulaciones: "Podeu incloure una o diverses titulacions, clicant sobre el nom d'aquella/es del vostre interès i tornant a desplegar el llistat. Veureu totes les que heu seleccionat marcades en color..",
			titulacion_seleccionada: "titulació seleccionada",
			titulaciones_seleccionadas: "titulacions seleccionades",
			nivel: "Nivell",
			areas: "Àrees",
			cualquier_area: "Qualsevol àrea",
			ninguna_titulacion: "Cap titulació no concorda amb el filtre de nivell indicat",
			eliminar_todas: "Eliminar-les totes",
			areas_dirige: "Àrees a les quals s'adreça l'oferta",
			titulaciones_dirige: "Titulacions a les quals s'adreça l'oferta",
			Seleccionau_titulaciones: "Seleccionau les titulacions del llistat de l'esquerra",
			cumplimentar: "Cumplimentar solo en el caso de que lo considere información relevante para los candidatos/as.",
			tipo_estudios: "Tipus d'estudis",
			seleccione_izquierda: "Seleccionau les àrees del llistat de l'esquerra",
			seleccione_algun_nivel: "Seleccionau algun nivell per carregar les àrees associades",
			especialidad_titulacion: "Especialitat o titulació/ons",
			puesto_trabajo: "Lloc de treball",
			motivo_rechazo: "Motiu de rebuig",
			ayuda_estudio: "Ajuda a l'estudi",
			tutor_empresa: "Tutor de la empresa",
			nombre_tutor: "Nom del tutor d'empresa",
			apellidos_tutor: "Cognoms del tutor empresa",
			email_tutor: "Email del tutor empresa",
			telefono_tutor: "Teléfono del tutor empresa",
			cargo_tutor: "Càrrec del tutor empresa",
			titulacion_tutor: "Titulación del tutor empresa",
			departamento_tutor: "Departamento del tutor empresa",
			dni_tutor: "DNI del tutor empresa",
			no_definido: "No definit",
			candidatos: "Candidats",
			exportar: "Exportar",
			no_hay_candidatos: "No hi ha candidats en aquesta oferta",
			mas: "més",
			menys: "menys",
			empresa_destino_simple: "Empresa destí",
			tipo_formacion: "Tipus de formació",
			niveles: "Nivells",
			areas: "Àrees",
			para_estudiantes_ultimo_curso: "Per a estudiants del darrer curs",
			estimacion_total_horas: "Estimació total hores"
		},
		filtro_oferta: {
			buscar_nombre: "Cerca per nom del lloc",
			buscar_localizacion: "Cerca per localització",
			buscar_titulacion: "Cerca per titulació",
			buscar_puesto: "Cerca per nom del lloc",
			filtro_avanzado: "Filtre avançat",
			cerrar: "Tancar",
			fecha_publicacion: "Data de publicació",
			fecha_inicio_previsa: "Data de començament de la pràctica prevista",
			fecha_inicio: "Data de començament",
			filtrado_etiqueta: "Filtrat per etiquetes",
			omitir_inscritos: "Ometre els inscrits",
			oferta_tfg: "Oferta TFG/TFM",
			ofertas_internacional: "Oferta internacional",
			ofertas_cv: "Ofertes que encaixen amb el meu perfil/cv",
			busquedas_guardadas: "Cerques guardades",
			guardar_busqueda: "Desar la cerca",
			borrar_filtros: "ESBORRAR FILTRES",
			ver: "Veure",
			fecha: "Data",
			se_han_encontrado: "S'han trobat",
			introduce_nombre_busqueda: "Introduïu el nom de la cerca",
			sobreescribe_existente: "ó sobreescribe una existente",
			selecciona_busqueda: "Seleccionau una cerca",
			ver_historico: "Veure històric d'ofertes",
			ver_actuales: "Veure ofertes actuals",
			crear_oferta: "CREAR OFERTA",
			historico_ofertas: "Històric d'ofertes",
			no_hay_ofertas: "No hi ha ofertes coincidents amb la vostra cerca",
			solo_con_candidatos: "Només ofertes amb candidats sense llegir",
			tienen_candidatos: "Tenen candidats ",
			caduca_pronto: "Caduquen aviat",
			no_leidos: "Solo no leidos"
		},
		popup_confirmacion: {
			recuerda: "Recorda!",
			titulo: "Assegurau-vos que les dades del vostre perfil estan actualitzades abans d'inscriure-us a una oferta",
			actualiza: "Actualitza'l clicant",
			aqui: "aquí",
			confirma_titulo: "Per favor, confirmau que voleu ser candidat en aquesta oferta",
			atencion: "Atenció!",
			necesitamos_anadir: "Cal que afegiu els documents següents per poder-vos inscriure a l'oferta",
			url_documento: "URL del document",
			por_favor_adjunta: "Per favor, adjuntau un arxiu o una URL",
			alumnos_master: "Els alumnes d'un màster de 2 anys de durada han de tenir almenys el 50% dels crèdits aprovats en haver de començar les pràctiques per poder fer-les Sou un alumne de màster de durada inferior a 2 anys o heu superat el 50% dels crèdits?"
		},
		encuestas_obligatorias: {
			titulo: "Enquestes obligatòries",
			cuerpo: "Per favor, abans de continuar, responeu aquestes enquestes",
			no_puedes: "No podreu accedir al portal fins que no hàgiu contestat les enquestes obligatòries Si no voleu respondre en aquest moment, podeu tancar la sessió",
		},
		header: {
			hola: "Hola, ",
			oferta_practicas: "Cercar ofertes de pràctiques",
			oferta_empleo: "Cercar ofertes de feina",
			propuesta_practicas: "Proposta de pràctiques",
			candidaturas: "Les meves candidatures",
			practicas: "Les meves pràctiques",
			programas: "Programes",
			encuestas: "Enquestes",
			eventos: "Esdeveniments",
			mi_cv: "El meu CV",
			guias_orientacion: "Guies d'orientació",
			mis_ofertas: "Les meves ofertes",
			nueva_oferta: "Nova oferta",
			solicitar_cambio_practicas: "Sol·licitar canvi de pràctiques",
			documentacion: "Documentació",
			solicitudes_practicas_educacion: "Sol·licituds pràctiques educació",
			encuestas: "Enquestes",
			mi_empresa: "La meva empresa",
			ayuda: "Ajuda",
			cerrar_sesion: "Tancar sessió",
			solicitar_baja: "Sol·licitar baixa"
		},
		image_uploader: {
			titulo : "Editar imatge de perfil",
			subtitulo: "Atenció: si és possible, pugeu una imatge de proporcions 1:1. Si pugeu una imatge allargada o apaïsada, podeu ajustar l'àrea de tall ampliant o reduint la imatge usant el seu scroll; a més podeu moure la imatge per ajustar l'àrea de retallada arrossegant-la amb el ratolí.",
		
		},
		notificaciones: {
			borrar_todo : "Esborrar-ho tot",
			importantes : "Importants",
			otras_notificaciones : "Altres notificacions",
			no_notificaciones : "No teniu notificacions pendents"
		},
		popup_borrar_cuenta: {
			titulo : "Voleu sol·licitar la baixa del servei i la supressió de les vostres dades personals?",
			si : "Sí",
			no : "No"
		},
		popup_pedir_naf: {
			titulo: "¡Atención!",
			subtitulo: "Todos los estudiantes deben aportar su Número de Seguridad Social (NSS o NAF) en su perfil. Debes completar:",
			parrafo1: "1. El campo Nº Seguridad social: en la sección de Datos personales de tu cv.",
			parrafo2: "2. Adjuntar el documento de acreditación del Número de la Seguridad Social en la sección Documentación adjunta, apartado disponible al final de tu cv.",
			pie: "Accede ya para cumplimentarlo.",
			ir: "Ir ahora",
		},
		popup_faltan_datos_empresa: {
			atencion : "Atenció!",
			cuerpo_1 : "Falten dades obligatòries en el vostre perfil Per favor, entrau-hi per completar-les",
			cuerpo_2 : "Falten dades obligatòries en el perfil de la vostra empresa Per favor, entrau-hi per completar-les",
			ir_a_perfil : "Anar al meu perfil",
			ir_a_empresa : "Anar a la meva empresa"
		},
		popup_datos_personales: {
			atencion : "Atenció!",
			titulo : "Abans de poder continuar heu de completar les dades obligatòries següents del vostre perfil:",
			ir_a_perfil : "Anar al meu perfil"
		},
		solicitudes_educacion: {
			titulo : "En aquesta secció trobareu la informació dels estudiants que han sol·licitat fer les pràctiques en el vostre centre",
			zero : "No hi ha documentació en aquests moments"
		},
		filtro_candidaturas: {
			buscar_nombre : "Cerca per nom del lloc",
			empleo : "Ocupació",
			practicas : "Pràctiques",
			filtro_avanzado : "Filtre avançat",
			cerrar : "Tancar",
			estado : "Estat",
			ver : "Veure",
			borrar_filtros : "ESBORRAR FILTRES",
			estas_en : "Estas en",
			zero : "No hi ha processos de selecció coincidents amb la vostra cerca"
		},
		documentacion: {
			intro : "En aquesta secció trobareu la documentació relacionada amb les pràctiques que s'han fet a la vostra empresa",
			convenio_titulo : "Convenis de col·laboració",
			caducado : "(Caducat) -",
			zero_convenio : "Encara no teniu cap conveni",
			titulo_convenio : "Si ho desitjau, podeu sol·licitar i descarregar el conveni de col·laboració, o aportar el document ja signat per la vostra empresa:",
			nuevo_convenio : "Nou conveni",
			subir_convenio : "Pujar conveni signat",
			anexos_practicas : "Annexos de pràctiques",
			zero_practicas : "Encara no teniu contingut",
			notas_formativas : "Notes formatives",
			en : "en",
			otros_documentos : "Altres documents associats a pràctiques",
			zero_documentos : "Encara no teniu cap document de pràctiques",
			otros_documentos_programas : "Altres documents associats a programes",
			zero_documentos_practicas : "Encara no teniu cap document associat a programes",
			documentos_aportados_empresa : "Altres documents aportats per l'empresa",
			no_documentos_anadidos : "No hi ha documents afegits Pitjau a «Afegir document» per afegir-los",
			anadir_documentacion : "Afegir documentació",
			Seleccionau_documento : "Seleccionau un document",
			listado_documento : "Llistat de documents",
			otro_tipo_documento : "Un altre tipus de document",
			nombre_documento : "Nom del document",
			url_documento : "URL del document",
		},
		encuestas: {
			titulo : "Enquestes",
			obligatorias : "Per continuar, responeu totes les preguntes obligatòries",
			enviar : "Enviar",
			pagina : "Pàgina",
			datos_enviados : "Les vostres dades han estat enviades",
			muchas_gracias : "Moltes gràcies!",
			Iniciaur_sesion : "Iniciau la sessió amb el vostre perfil d'usuari",
			empresa : "Empresa",
			candidato : "Candidato",
			usuario : "Usuario",
			contrasena : "Contrasenya",
			acceder : "Accedir-hi",
			o : "ó",
			acceder_anonimamente : "Acceder anonimamente",
			contestar_pregunta : "Heu de contestar aquesta pregunta per poder continuar",
			zero : "No hi ha enquestes disponibles"
		},
		eventos: {
			proximos : "Pròxims esdeveniments",
			pasados : "Esdeveniments passats",
			evento_destacado : "Esdeveniment destacat",
			desde : "Des de",
			hasta : "Fins",
			organizado_por : "Organitzat per",
			inscribirse : "Inscriure's",
			inscrito : "Inscrit",
			mas_informacion : "Més informació",
			galeria : "Galeria d'imatges",
			videos : "Vídeos",
			buscar_localizacion : "Cercar per localització",
			buscar_categoria : "Cercar per categoria",
			buscar_nombre : "Cercar per nom",
			eventos_pasados : "Esdeveniments passats",
			ver_mas : "Veure més"
		},
		comunicaciones: {
			titulo : "Comunicacions"
		},
		guias: {
			titulo : "Darreres guies d'orientació",
			zero : "No hi ha guies d'orientació"
		},
		ofertas: {
			ultimas_practicas : "Darreres ofertes de pràctiques",
			practicas : "Pràctiques",
			ultimas_empleo : "Darreres ofertes d'ocupació",
			empleo : "Ocupació",
			ofertas : "Ofertes",
			zero_ofertas : "No hi ha ofertes disponibles",
			ver_todas: "Veure totes",
			ver_todas_ofertas_actuales: "Veure totes les ofertes de pràctiques actuals pel teu perfil",
		},
		cv: {
			nivel : "Nivell",
			programa_informatico : "Programa informàtic",
			certificado : "Certificat",
			sin_nivel : "Sense nivell definit",
			presentacion : "Presentació",
			anadir_presentacion : "Per afegir la vostra presentació pitjau",
			aqui : "aquí",
			otros_intereses : "Altres interessos",
			tus_interes : "Els vostres interessos",
			sin_intereses : "Sense interessos especificats",
			escribe_interes : "Escribe algún interes, para comenzar a buscar",
			click_interes : "Haz click sobre el interes, para añadirlo",
			click_cambiar_imagen : "Clicau per canviar la imatge",
			cambiar_contrasena : "Canviar contrasenya",
			idiomas : "Idiomes",
			idioma : "Idioma",
			sin_idiomas : "Sense idiomes afegits Premeu a «Afegir idioma» per afegir-lo",
			idioma_obligatorio : "L'idioma i el nivell són camps obligatoris per afegir un idioma",
			nivel_no_definido : "Nivell no definit",
			nivel : "Nivell",
			nombre_certificado : "Nom del certificat",
			estancia_extranjero : "Estada a l'estranger",
			pais_estancia : "País d'estada",
			motivo_estancia : "Motiu de l'estància",
			duracion_meses : "Durada en mesos",
			experiencia_profesional : "Experiència professional",
			anadir_nueva_experiencia : "Afegir nova experiència",
			sin_experiencia : "Sense experiència",
			actualidad : "Actualitat",
			puesto : "Titulo del puesto",
			sector_empresa : "Sector de l'empresa",
			area_actividad_puesto : "Àrea d'activitat del lloc",
			tipo_contrato : "Tipus de contracte",
			subtipo_contrato : "Subtipus de contracte",
			ver_adjunto : "Veure l'adjunt",
			ver_enlace : "Veure enllaç",
			duracion : "Durada",
			fecha_inicio : "Data de començament",
			fecha_fin : "Data de finalització",
			provincia : "Província",
			empresa : "Empresa",
			enlace : "Enllaç",
			descripcion_puesto : "Descripció del lloc",
			escribe_descripcion : "Escriviu una descripció de les tasques exercides",
			anadir_fichero : "Afegir fitxer adjunt",
			adjunto_correctamente : "Arxiu adjuntat correctament",
			programas_informaticos: {
				titulo : "Programes informàtics",
				buscar : "Escriviu per cercar",
				zero : "No hi ha programes informàtics afegits Pitjau a «Afegir» per a afegir-los",
				anadir : "Añadir Programa",
			},
			documentacion_adjunta : "Documentació adjunta",
			documentacion_subida : "Documentació pujada el",
			no_hay_documentos : "No hi ha documents afegits",
			pulsa_anadir_documentos : ", Clicau a afegir document per afegir-lo",
			anadir_documentacion : "Afegir documentació",
			Seleccionau_documento : "Seleccionau un document",
			listado_documento : "Llistat de documents",
			otro_tipo_documento : "Un altre tipus de document",
			nombre_documento : "Nom del document",
			url_documento : "URL del document",
			documentacion_privada : "Documentació privada",
			no_documentos : "No hi ha documents afegits Pitjau a «Afegir document» per afegir-los",
			documentacion_ligada : "Documentació lligada a processos",
			datos_profesionales : "Dades professionals",
			visitar : "Visitar",
			indica_link_perfil : "Indicau l'enllaç al vostre perfil",
			trabajando_actualmente : "Treballant actualment",
			permiso_trabajo : "Permís de treball a la UE",
			anos_experiencia : "Anys d'experiència",
			sin_experiencia : "Sense experiència",
			disfrutado_erasmus : "He estat d'Erasmus o he gaudit d'una altra beca de mobilitat",
			minima_retribucion : "Mínima retribució",
			brutos_anuales : "/ bruts anuals",
			datos_personales : "Dades personals",
			dni : "DNI",
			fecha_nacimiento : "Data de naixement",
			genero : "Gènere",
			femenino : "Femení",
			masculino : "Masculí",
			email_personal : "Adreça electrònica personal",
			email_estudiante : "Adreça electrònica de l'estudiant",
			avisos_en_email : "Avisos a l'adreça electrònica personal",
			acepta_newsletter : "Accepta el butlletí",
			idioma_comunicaciones : "Idioma preferit per a les comunicacions",
			movil : "Mòbil",
			fijo : "Telèfon fix",
			direccion_empadronamiento : "Adreça d'empadronament",
			direccion_actual : "Adreça actual",
			direccion : "Adreça",
			iban : "Núm compte IBAN",
			seguridad_social : "Núm Seguretat Social",
			pais_nacionalidad : "País de nacionalitat",
			pais_segunda_nacionalidad : "País de segona nacionalitat",
			provincia_nacimiento : "Província de naixement",
			provincia : "Província",
			lugar_nacimiento : "Lloc de naixement",
			discapacidad : "Discapacitat superior al 33%",
			deseo_recibir_comunicaciones : "Vull rebre comunicacions relacionades amb orientació i serveis relacionats amb la formació superior i la UIB:",
			nombre : "Nom",
			primer_apellido : "Primer cognom",
			segundo_apellido : "Segon cognom",
			tipo_identificacion : "Tipus d'identificació",
			documento_identidad : "Document d'identitat",
			buscar : "Escriviu per cercar",
			cp : "Codi postal",
			pais : "País",
			localidad : "Localitat",
			tipo_via : "Tipus de via",
			numero : "Número",
			piso : "Pis",
			puerta: "Puerta",
			notas: "Notas",
			datos_academicos: "Datos académicos",
			formacion_complementaria: "Formación complementaria",
			anadir_titulacion: "Añadir nueva titulación",
			complementaria: "complementaria",
			centro: "Centro",
			tipo: "Tipo",
			nota: "Nota",
			rama_ensenanza: "Rama de la enseñanza",
			duracion: "Duración",
			actual: "Actual",
			si: "Sí",
			no: "No",
			titulo: "Titulo",
			universidad: "Universidad/Lugar de estudios",
			calificacion: "Calificación",
			calificacion_media: "Calificación media del titulo",
			horas: "Horas",
			ambito: "Ambito de la enseñanza",
			selecciona_tipo: "- Selecciona un tipo -",
			certificacion: "Certificación",
			tienes_cerfificacion: "¿Tienes certificación?",
			competencias_profesionales: "Competencias profesionales",
			tus_competencias: "Tus competencias",
			sin_competencias: "Sin competencias profesionales especificadas",
			solicitar_sesion: "Puedes solicitar una sesión gratuita de orientación con DOIP UIB.",
			datos_interes: "Datos de interés",
			competencias: "Competencias",
			busqueda_activa_practicas: "Búsqueda activa de prácticas",
			busqueda_activa_empleo: "Búsqueda activa de empleo",
			disponible_extranjero: "Disponible para trabajar en el extranjero",
			permiso_conducir: "Permiso de conducir",
			disponible_cambio_residencia: "Disponible para cambio de residencia",
			coche_propio: "Coche propio",
			disponible_viajar: "Disponible para viajar",
			discapacidad_certificada: "Discapacidad certificada",
			observaciones: "Observacions",
			carnet_moto: "Carnet de moto",
			moto_propia: "Moto propia",
			disponibilidad_jornadas: "Disponilidad de jornadas",
			periodo_preferencia_practicas: "Periodo preferencia de prácticas",
			selecciona: "Selecciona"
		},
		addtitulacion: {
			titulo: "Titulaciones a las que se dirige la oferta",
			seleccione_areas: "Seleccione área/s para filtrar titulaciones",
			borrar_areas: "Borrar todas las áreas",
			cualquier_area: "Cualquier área",
			escriba_aqui: "Escriba aquí para filtrar el listado de titulaciones a continuación",
			selecciona_titulacion: "Seleccione la titulación/es a la/s que se dirige la oferta haciendo clic sobre ella/s",
			ver_titulaciones: "Ver titulaciones de grado",
			listadas: "listadas",
			listados: "listados",
			cualquier_titulacion: "Cualquiera de estas titulaciones de grado",
			ver_titulaciones_postgrado: "Ver titulaciones de postgrado",
			cualquier_titulacion_postgrado: "Cualquiera de estas titulaciones de postgrado",
			ver_titulaciones_propio: "Ver titulaciones de Título propio",
			cualquier_titulacion_propio: "Cualquiera de estos títulos propios",
			lo_sentimos: "Lo sentimos no se han encontrado titulaciones que coincidan con la búsqueda",
			listado_titulaciones_seleccionadas: "Listado de titulaciones seleccionadas",
			eliminar_titulaciones: "Eliminar todas las titulaciones seleccionadas"
		},
		candidato: {
			nuevo: "Nuevo",
			cambiar_estado: "Cambiar estado",
			ver_cv: "Ver CV",
			detalles: "Detalles del candidato/a",
			selecciona_estado: "Selecciona un estado",
			seleccione_motivo: "Por favor seleccione el motivo de rechazo del candidato/a.",
			cambio_estado: "Cambio de estado",
			descargar_cv: "Descargar CV"

		},
		cambio_practicas: {
			identifica: "Identifica el alumno/a del que solicitan realizar prórroga o variación de sus condiciones de prácticas.",
			alumno: "Alumno",
			selecciona_oferta: "Selecciona la oferta",
			no_practicas: "Aún no tienes ninguna práctica sobre la que puedas solicitar un cambio.",
			alumno: "Alumno/a",
			selecciona_alumno: "Selecciona el alumno/a",
			detalles: "Detalles de la modificación",
			tipo_modificacion: "Tipo de modificación",
			selecciona_modificacion: "-Selecciona la modificación-",
			otros_detalles: "Otros detalles",
			adjunto: "Adjunto",
			solicitar_cambio: "Solicitar cambio"
		}


	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js